import Vue from 'vue';
import { getAttributes, getData } from '@gooroo-life/goo-ui-icons';

let uuid = 0;
var UniqueId = {
  data() {
    return {
      uuid: (++uuid).toString()
    };
  },

  computed: {
    idString() {
      return `${this.$options.name}-${this.uuid}`;
    }

  },
  methods: {
    keyedId(key) {
      return `${this.idString}-${key.toString()}`;
    }

  }
};

//
/* TODO: This component should likely be rewritten to be with a render function, allowing the client full control
*  over both the trigger and default slot. Currently, you cannot attach event listeners/analytics to the trigger
*/

var script = {
  name: "goo-accordion",
  mixins: [UniqueId],
  props: {
    title: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      open: false
    };
  },

  methods: {
    onClick() {
      this.open = !this.open;

      if (this.open) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  const options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  let hook;

  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      const originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      const existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "goo-accordion", class: { "is-active": _vm.open } },
    [
      _c(
        "button",
        {
          staticClass: "goo-accordion-trigger icon-button",
          attrs: { "aria-controls": _vm.idString, "aria-expanded": _vm.open },
          on: { click: _vm.onClick }
        },
        [
          _vm._t("trigger", [
            _c(
              "span",
              {
                staticClass:
                  "goo-accordion-title goo-link is-alternate has-text-left"
              },
              [_vm._v(_vm._s(_vm.title))]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-open" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            staticClass: "goo-accordion-content",
            attrs: { id: _vm.idString }
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

const registerComponent = (Vue, component) => {
  Vue.component(component.name, component);
};
const registerInstanceComponent = (Vue, property, component) => {
  if (!Vue.prototype.$goo) Vue.prototype.$goo = {};
  Vue.prototype.$goo[property] = component;
};

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};

var GooBackgroundVideo = {
  name: 'goo-background-video',
  props: {},

  data() {
    return {
      playing: false,
      videoElement: null
    };
  },

  computed: {
    isMobile() {
      let agent = navigator.userAgent || navigator.vendor || window.opera;
      return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(agent.substr(0, 4));
    },

    canPlay() {
      return !this.isMobile;
    }

  },

  render() {
    return this.$scopedSlots.default({
      playing: this.playing,
      canPlay: this.canPlay
    });
  },

  methods: {
    loadSources() {
      let sources = Array.from(this.videoElement.querySelectorAll('source'));
      sources.forEach(source => {
        source.setAttribute('src', source.getAttribute('data-src'));
      });
    },

    onVideoPlay() {
      this.playing = true;
    },

    onVideoEnded() {
      this.playing = false; // FIXME this is a hack to loop the video ourselves with a very brief pause between iterations to sync css animations

      setTimeout(() => {
        this.videoElement.play();
      }, 50);
    }

  },

  mounted() {
    this.videoElement = this.$el.querySelector('video');

    if (this.canPlay) {
      this.videoElement.addEventListener('play', this.onVideoPlay);
      this.videoElement.addEventListener('ended', this.onVideoEnded);
      this.loadSources();
    }
  }

};

const Plugin$1 = {
  install(Vue) {
    registerComponent(Vue, GooBackgroundVideo);
  }

};

//
//
//
//
//
//
var script$1 = {
  name: "goo-badge",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: null
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: "goo-badge" } }, [
    _vm.active
      ? _c("span", { staticClass: "goo-badge" }, [_vm._v(_vm._s(_vm.value))])
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$2 = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$1);
  }

};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var lib = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * @description A module for parsing ISO8601 durations
   */

  /**
   * The pattern used for parsing ISO8601 duration (PnYnMnDTnHnMnS).
   * This does not cover the week format PnW.
   */
  // PnYnMnDTnHnMnS

  var numbers = '\\d+(?:[\\.,]\\d+)?';
  var weekPattern = '(' + numbers + 'W)';
  var datePattern = '(' + numbers + 'Y)?(' + numbers + 'M)?(' + numbers + 'D)?';
  var timePattern = 'T(' + numbers + 'H)?(' + numbers + 'M)?(' + numbers + 'S)?';
  var iso8601 = 'P(?:' + weekPattern + '|' + datePattern + '(?:' + timePattern + ')?)';
  var objMap = ['weeks', 'years', 'months', 'days', 'hours', 'minutes', 'seconds'];
  /**
   * The ISO8601 regex for matching / testing durations
   */

  var pattern = exports.pattern = new RegExp(iso8601);
  /** Parse PnYnMnDTnHnMnS format to object
   * @param {string} durationString - PnYnMnDTnHnMnS formatted string
   * @return {Object} - With a property for each part of the pattern
   */

  var parse = exports.parse = function parse(durationString) {
    // Slice away first entry in match-array
    return durationString.match(pattern).slice(1).reduce(function (prev, next, idx) {
      prev[objMap[idx]] = parseFloat(next) || 0;
      return prev;
    }, {});
  };
  /**
   * Convert ISO8601 duration object to an end Date.
   *
   * @param {Object} duration - The duration object
   * @param {Date} startDate - The starting Date for calculating the duration
   * @return {Date} - The resulting end Date
   */


  var end = exports.end = function end(duration, startDate) {
    // Create two equal timestamps, add duration to 'then' and return time difference
    var timestamp = startDate ? startDate.getTime() : Date.now();
    var then = new Date(timestamp);
    then.setFullYear(then.getFullYear() + duration.years);
    then.setMonth(then.getMonth() + duration.months);
    then.setDate(then.getDate() + duration.days);
    then.setHours(then.getHours() + duration.hours);
    then.setMinutes(then.getMinutes() + duration.minutes); // Then.setSeconds(then.getSeconds() + duration.seconds);

    then.setMilliseconds(then.getMilliseconds() + duration.seconds * 1000); // Special case weeks

    then.setDate(then.getDate() + duration.weeks * 7);
    return then;
  };
  /**
   * Convert ISO8601 duration object to seconds
   *
   * @param {Object} duration - The duration object
   * @param {Date} startDate - The starting point for calculating the duration
   * @return {Number}
   */


  var toSeconds = exports.toSeconds = function toSeconds(duration, startDate) {
    var timestamp = startDate ? startDate.getTime() : Date.now();
    var now = new Date(timestamp);
    var then = end(duration, now);
    var seconds = (then.getTime() - now.getTime()) / 1000;
    return seconds;
  };

  exports.default = {
    end: end,
    toSeconds: toSeconds,
    pattern: pattern,
    parse: parse
  };
});

function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/
const ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}


const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
      isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,9}))?)?)?/,
      isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${offsetRegex.source}?`),
      isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`),
      isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
      isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
      isoOrdinalRegex = /(\d{4})-?(\d{3})/,
      sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
      // dumbed-down version of the ISO one
sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`),
      sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);

const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);

const lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1000
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1000
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1000
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1000
  },
  seconds: {
    milliseconds: 1000
  }
},
      casualMatrix = Object.assign({
  years: {
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1000
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix),
      daysInYearAccurate = 146097.0 / 400,
      daysInMonthAccurate = 146097.0 / 4800,
      accurateMatrix = Object.assign({
  years: {
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix); // units ordered by size

const numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};

const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");

const DATE_ALIASES = {
  "years": "fullYear",
  "y": "fullYear",
  "M": "month",
  "months": "month",
  "w": "weeks",
  // conversion for days
  "d": "date",
  "days": "date",
  "h": "hours",
  "m": "minutes",
  "s": "seconds",
  "ms": "milliseconds"
};
const DATE_MUTATORS = {
  "setWeeks": function (date, delta) {
    date.setDate(date.getDate() + delta * 7);
  }
};

function parse(date) {
  if (typeof date === "object") {
    return new Date(date.getTime());
  }

  if (typeof date === "string") {
    return fromISO8601String(date);
  }
}
function fromISO8601String(iso8601String) {
  if (_containsTimezone(iso8601String)) {
    return new Date(iso8601String);
  }

  let parts = iso8601String.split(/[: T-]/).map(parseFloat);
  const date = new Date(parts[0], (parts[1] || 1) - 1, parts[2] || 1, parts[3] || 0, parts[4] || 0, parts[5] || 0, 0); //Allows setting dates with a year between 0 and 99. Otherwise, a value like 98 would be interpreted as 1998;

  date.setFullYear(parts[0]);
  return date;
}

function _containsTimezone(iso8601String) {
  const parts = iso8601String.split(/[: T-]/).map(parseFloat);

  if (parts.length < 6) {
    //Timezone information is only relevant if we have all of the preceding the date and time pieces
    return false;
  }

  return /[Z\-+][0-9:]*$/gm.test(iso8601String);
}
function toTimeString(date, options) {
  return parse(date).toLocaleTimeString([], options);
}
function toTinyTimeString(date) {
  return toTimeString(date, {
    hour: "numeric",
    minute: "2-digit"
  }).toLowerCase().replace(" ", "");
}

function add(date, units, delta) {
  return _delta(date, units, delta);
}
function subtract(date, units, delta) {
  return _delta(date, units, -1 * delta);
}
function _delta(date, units, delta) {
  const d = new Date(date);
  const dateUnits = capitalize(units in DATE_ALIASES ? DATE_ALIASES[units] : units);
  const setFnName = `set${dateUnits}`;
  const getFnName = `get${dateUnits}`;

  if (typeof DATE_MUTATORS[setFnName] === "function") {
    DATE_MUTATORS[setFnName](d, delta);
  } else if (typeof d[setFnName] === "function" && typeof d[getFnName] === "function") {
    d[setFnName].call(d, d[getFnName].call(d) + delta);
  } else {
    throw Error("Invalid unit descriptor");
  }

  return d;
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  name: "goo-calendar-cell",
  props: {
    day: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canAdd: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-calendar-cell" }, [
    _c("div", { staticClass: "goo-calendar-day-cell-header" }, [
      _c("span", { staticClass: "goo-calendar-cell-label" }, [
        _c(
          "span",
          { staticClass: "goo-calendar-weekday-label hide-large-up" },
          [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.day.date.toLocaleDateString([], { weekday: "short" })
                ) +
                "\n            "
            )
          ]
        ),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.day.date.toLocaleDateString([], {
                  month: "short",
                  day: "2-digit"
                })
              ) +
              "\n            "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "goo-calendar-day-cell-content" },
      [_vm._t("default")],
      2
    )
  ])
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

//
var script$3 = {
  name: "goo-calendar",
  components: {
    GooCalendarCell: __vue_component__$2
  },
  props: {
    weeksAhead: {
      type: Number,
      default: 2
    },
    minDate: {
      type: Date,
      required: true
    },
    todayDate: {
      type: Date,

      default() {
        return new Date();
      }

    },
    isDayActive: {
      type: Function,

      default(day) {
        return true;
      }

    }
  },
  computed: {
    minDay() {
      const min = new Date(this.minDate);
      return this.atMidnight(min);
    },

    maxDay() {
      const max = subtract(add(this.today, 'weeks', this.weeksAhead), 'days', 1);
      return this.atMidnight(max);
    },

    today() {
      const today = new Date(this.todayDate);
      return this.atMidnight(today);
    },

    daysOfWeek() {
      return Array(7).fill().map((value, index) => {
        const day = add(this.beginningOfThisWeek, 'days', index);
        return day.toLocaleDateString([], {
          weekday: "short"
        });
      });
    },

    beginningOfThisWeek() {
      // TODO Make a helper method to find the previous weekeday from date
      return subtract(this.today, 'days', this.today.getDay()); // Set to previous sunday
    },

    endOfFinalWeek() {
      const date = add(this.today, 'weeks', this.weeksAhead); // TODO Make a helper method to find the previous weekeday from date

      if (date.getDay() == 6) {
        return date;
      }

      date.setDate(date.getDate() - date.getDay() - 1); // Set to previous saturday

      return date;
    },

    weeks() {
      const weeks = [];
      const days = this.daysInRange(this.beginningOfThisWeek, this.endOfFinalWeek);
      days.forEach(day => {
        if (day.date.getDay() == 0) {
          weeks.push([]);
        }

        weeks[weeks.length - 1].push(day);
      });
      return weeks;
    },

    days() {
      return this.daysInRange(this.today, this.endOfFinalWeek);
    }

  },
  methods: {
    isToday(day) {
      return this.today - day.date == 0;
    },

    daysInRange(start, end) {
      const days = [];
      let current = new Date(start);

      while (current <= end) {
        const day = new Date(current);
        days.push({
          date: day,
          enabled: day >= this.minDay
        });
        current.setDate(current.getDate() + 1);
      }

      return days;
    },

    atMidnight(date) {
      const midnight = new Date(date);
      midnight.setHours(0);
      midnight.setMinutes(0);
      midnight.setSeconds(0);
      midnight.setMilliseconds(0);
      return midnight;
    }

  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-calendar" }, [
    _c("table", { staticClass: "goo-calendar-grid hide-large-down" }, [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.daysOfWeek, function(dayOfWeek) {
            return _c(
              "th",
              {
                staticClass:
                  "goo-calendar-weekday has-text-centered has-text-bold"
              },
              [_vm._v(_vm._s(dayOfWeek) + "\n            ")]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.weeks, function(week) {
          return _c(
            "tr",
            { staticClass: "goo-calendar-week" },
            _vm._l(week, function(day) {
              return _c(
                "td",
                {
                  staticClass: "goo-calendar-day-cell",
                  class: {
                    "is-disabled": !day.enabled,
                    "is-active": _vm.isDayActive(day)
                  }
                },
                [
                  _c(
                    "goo-calendar-cell",
                    { attrs: { day: day } },
                    [
                      [
                        _vm._t("default", null, {
                          isToday: _vm.isToday(day),
                          day: day
                        })
                      ]
                    ],
                    2
                  )
                ],
                1
              )
            }),
            0
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "goo-calendar-grid hide-large-up" }, [
      _c(
        "tbody",
        _vm._l(_vm.days, function(day) {
          return _c("tr", [
            day.enabled || _vm.isToday(day)
              ? _c(
                  "td",
                  {
                    staticClass: "goo-calendar-day-cell",
                    class: {
                      "is-disabled": !day.enabled,
                      "is-active": _vm.isDayActive(day)
                    }
                  },
                  [
                    _c(
                      "goo-calendar-cell",
                      { attrs: { day: day } },
                      [
                        [
                          _vm._t("default", null, {
                            isToday: _vm.isToday(day),
                            day: day
                          })
                        ]
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        }),
        0
      )
    ])
  ])
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$3 = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$3);
    registerComponent(Vue, __vue_component__$2);
  }

};

const debounce = (fn, delay) => {
  let timeoutID = null;
  return function () {
    const args = arguments;
    const context = this;
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
};

var swipe = createCommonjsModule(function (module) {

  (function (root, factory) {
    root = root || {}; // eslint-disable-next-line no-undef

    if ( module.exports) {
      // Node. Does not work with strict CommonJS, but
      // only CommonJS-like environments that support module.exports,
      // like Node.
      module.exports = factory();
    } else {
      // Browser globals
      root.Swipe = factory();
    }
  })(commonjsGlobal, function () {
    // Establish the root object, `window` (`self`) in the browser, `global`
    // on the server, or `this` in some virtual machines. We use `self`
    // instead of `window` for `WebWorker` support.
    var root = typeof self == 'object' && self.self === self && self || typeof commonjsGlobal == 'object' && commonjsGlobal.global === commonjsGlobal && commonjsGlobal || this;
    var _document = root.document;

    function Swipe(container, options) {

      options = options || {}; // setup initial vars

      var start = {};
      var delta = {};
      var isScrolling; // setup auto slideshow

      var delay = options.auto || 0;
      var interval;
      var disabled = false; // utilities
      // simple no operation function

      var noop = function () {}; // offload a functions execution


      var offloadFn = function (fn) {
        setTimeout(fn || noop, 0);
      }; // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered.


      var throttle = function (fn, threshhold) {
        threshhold = threshhold || 100;
        var timeout = null;

        function cancel() {
          if (timeout) clearTimeout(timeout);
        }

        function throttledFn() {
          var context = this;
          var args = arguments;
          cancel();
          timeout = setTimeout(function () {
            timeout = null;
            fn.apply(context, args);
          }, threshhold);
        } // allow remove throttled timeout


        throttledFn.cancel = cancel;
        return throttledFn;
      }; // check whether event is cancelable


      var isCancelable = function (event) {
        if (!event) return false;
        return typeof event.cancelable !== 'boolean' || event.cancelable;
      }; // polyfill for browsers that do not support Element.matches()


      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(s),
              i = matches.length;

          while (--i >= 0 && matches.item(i) !== this);

          return i > -1;
        };
      } // check browser capabilities


      var browser = {
        addEventListener: !!root.addEventListener,
        passiveEvents: function () {
          // Test via a getter in the options object to see if the passive property is accessed
          var supportsPassive = false;

          try {
            var opts = Object.defineProperty({}, 'passive', {
              // eslint-disable-next-line getter-return
              get: function () {
                supportsPassive = true;
              }
            });
            root.addEventListener('testEvent', null, opts);
            root.removeEventListener('testEvent', null, opts);
          } catch (e) {
            supportsPassive = false;
          }

          return supportsPassive;
        }(),
        // eslint-disable-next-line no-undef
        touch: 'ontouchstart' in root || root.DocumentTouch && _document instanceof DocumentTouch,
        transitions: function (temp) {
          var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];

          for (var i in props) {
            if (temp.style[props[i]] !== undefined) {
              return true;
            }
          }

          return false;
        }(_document.createElement('swipe'))
      }; // quit if no root element

      if (!container) return;
      var element = container.children[0];
      var slides, slidePos, width, length;
      var index = parseInt(options.startSlide, 10) || 0;
      var speed = options.speed || 300;
      options.continuous = options.continuous !== undefined ? options.continuous : true; // check text direction

      var slideDir = function (el, prop, dir) {
        if (el.currentStyle) {
          dir = el.currentStyle[prop];
        } else if (root.getComputedStyle) {
          dir = root.getComputedStyle(el, null).getPropertyValue(prop);
        }

        return 'rtl' === dir ? 'right' : 'left';
      }(container, 'direction'); // AutoRestart option: auto restart slideshow after user's touch event


      options.autoRestart = options.autoRestart !== undefined ? options.autoRestart : false; // throttled setup

      var throttledSetup = throttle(setup); // setup event capturing

      var events = {
        handleEvent: function (event) {
          if (disabled) return;

          switch (event.type) {
            case 'mousedown':
            case 'touchstart':
              this.start(event);
              break;

            case 'mousemove':
            case 'touchmove':
              this.move(event);
              break;

            case 'mouseup':
            case 'mouseleave':
            case 'touchend':
              this.end(event);
              break;

            case 'webkitTransitionEnd':
            case 'msTransitionEnd':
            case 'oTransitionEnd':
            case 'otransitionend':
            case 'transitionend':
              this.transitionEnd(event);
              break;

            case 'resize':
              throttledSetup();
              break;
          }

          if (options.stopPropagation) {
            event.stopPropagation();
          }
        },
        start: function (event) {
          var touches;

          if (isMouseEvent(event)) {
            touches = event;
            event.preventDefault(); // For desktop Safari drag
          } else {
            touches = event.touches[0];
          } // check if the user is swiping on an element that the options say to ignore (for example, a scrolling area)


          if (options.ignore && touches.target.matches(options.ignore)) {
            return;
          } // measure start values


          start = {
            // get initial touch coords
            x: touches.pageX,
            y: touches.pageY,
            // store time to determine touch duration
            time: +new Date()
          }; // used for testing first move event

          isScrolling = undefined; // reset delta and end measurements

          delta = {}; // attach touchmove and touchend listeners

          if (isMouseEvent(event)) {
            element.addEventListener('mousemove', this, false);
            element.addEventListener('mouseup', this, false);
            element.addEventListener('mouseleave', this, false);
          } else {
            element.addEventListener('touchmove', this, browser.passiveEvents ? {
              passive: false
            } : false);
            element.addEventListener('touchend', this, false);
          }

          runDragStart(getPos(), slides[index]);
        },
        move: function (event) {
          var touches;

          if (isMouseEvent(event)) {
            touches = event;
          } else {
            // ensure swiping with one touch and not pinching
            if (event.touches.length > 1 || event.scale && event.scale !== 1) {
              return;
            } // we can disable scrolling unless it is already in progress


            if (options.disableScroll && isCancelable(event)) {
              event.preventDefault();
            }

            touches = event.touches[0];
          } // measure change in x and y


          delta = {
            x: touches.pageX - start.x,
            y: touches.pageY - start.y
          }; // determine if scrolling test has run - one time test

          if (typeof isScrolling === 'undefined') {
            isScrolling = !!(isScrolling || Math.abs(delta.x) < Math.abs(delta.y));
          } // if user is not trying to scroll vertically


          if (!isScrolling) {
            // if it is not already scrolling
            if (isCancelable(event)) {
              // prevent native scrolling
              event.preventDefault();
            } // stop slideshow


            stop(); // increase resistance if first or last slide

            if (options.continuous) {
              // we don't add resistance at the end
              translate(circle(index - 1), delta.x + slidePos[circle(index - 1)], 0);
              translate(index, delta.x + slidePos[index], 0);
              translate(circle(index + 1), delta.x + slidePos[circle(index + 1)], 0);
            } else {
              delta.x = delta.x / (!index && delta.x > 0 || // if first slide and sliding left
              index === slides.length - 1 && // or if last slide and sliding right
              delta.x < 0 // and if sliding at all
              ? Math.abs(delta.x) / width + 1 : // determine resistance level
              1); // no resistance if false
              // translate 1:1

              translate(index - 1, delta.x + slidePos[index - 1], 0);
              translate(index, delta.x + slidePos[index], 0);
              translate(index + 1, delta.x + slidePos[index + 1], 0);
            }
          }
        },
        end: function (event) {
          // measure duration
          var duration = +new Date() - start.time; // determine if slide attempt triggers next/prev slide

          var isValidSlide = Number(duration) < 250 && // if slide duration is less than 250ms
          Math.abs(delta.x) > 20 || // and if slide amt is greater than 20px
          Math.abs(delta.x) > width / 2; // or if slide amt is greater than half the width
          // determine if slide attempt is past start and end

          var isPastBounds = !index && delta.x > 0 || // if first slide and slide amt is greater than 0
          index === slides.length - 1 && delta.x < 0; // or if last slide and slide amt is less than 0

          if (options.continuous) {
            isPastBounds = false;
          } // OLD determine direction of swipe (true:right, false:left)
          // determine direction of swipe (1: backward, -1: forward)


          var direction = Math.abs(delta.x) / delta.x; // if not scrolling vertically

          if (!isScrolling) {
            if (isValidSlide && !isPastBounds) {
              // if we're moving right
              if (direction < 0) {
                if (options.continuous) {
                  // we need to get the next in this direction in place
                  move(circle(index - 1), -width, 0);
                  move(circle(index + 2), width, 0);
                } else {
                  move(index - 1, -width, 0);
                }

                move(index, slidePos[index] - width, speed);
                move(circle(index + 1), slidePos[circle(index + 1)] - width, speed);
                index = circle(index + 1);
              } else {
                if (options.continuous) {
                  // we need to get the next in this direction in place
                  move(circle(index + 1), width, 0);
                  move(circle(index - 2), -width, 0);
                } else {
                  move(index + 1, width, 0);
                }

                move(index, slidePos[index] + width, speed);
                move(circle(index - 1), slidePos[circle(index - 1)] + width, speed);
                index = circle(index - 1);
              }

              runCallback(getPos(), slides[index], direction);
            } else {
              if (options.continuous) {
                move(circle(index - 1), -width, speed);
                move(index, 0, speed);
                move(circle(index + 1), width, speed);
              } else {
                move(index - 1, -width, speed);
                move(index, 0, speed);
                move(index + 1, width, speed);
              }
            }
          } // kill touchmove and touchend event listeners until touchstart called again


          if (isMouseEvent(event)) {
            element.removeEventListener('mousemove', events, false);
            element.removeEventListener('mouseup', events, false);
            element.removeEventListener('mouseleave', events, false);
          } else {
            element.removeEventListener('touchmove', events, browser.passiveEvents ? {
              passive: false
            } : false);
            element.removeEventListener('touchend', events, false);
          }

          runDragEnd(getPos(), slides[index]);
        },
        transitionEnd: function (event) {
          var currentIndex = parseInt(event.target.getAttribute('data-index'), 10);

          if (currentIndex === index) {
            if (delay || options.autoRestart) restart();
            runTransitionEnd(getPos(), slides[index]);
          }
        }
      }; // trigger setup

      setup(); // start auto slideshow if applicable

      begin(); // Expose the Swipe API

      return {
        // initialize
        setup: setup,
        // go to slide
        slide: function (to, speed) {
          stop();
          slide(to, speed);
        },
        // move to previous
        prev: function () {
          stop();
          prev();
        },
        // move to next
        next: function () {
          stop();
          next();
        },
        // Restart slideshow
        restart: restart,
        // cancel slideshow
        stop: stop,
        // return current index position
        getPos: getPos,
        // disable slideshow
        disable: disable,
        // enable slideshow
        enable: enable,
        // return total number of slides
        getNumSlides: function () {
          return length;
        },
        // completely remove swipe
        kill: kill
      }; // remove all event listeners

      function detachEvents() {
        if (browser.addEventListener) {
          // remove current event listeners
          element.removeEventListener('touchstart', events, browser.passiveEvents ? {
            passive: true
          } : false);
          element.removeEventListener('mousedown', events, false);
          element.removeEventListener('webkitTransitionEnd', events, false);
          element.removeEventListener('msTransitionEnd', events, false);
          element.removeEventListener('oTransitionEnd', events, false);
          element.removeEventListener('otransitionend', events, false);
          element.removeEventListener('transitionend', events, false);
          root.removeEventListener('resize', events, false);
        } else {
          root.onresize = null;
        }
      } // add event listeners


      function attachEvents() {
        if (browser.addEventListener) {
          // set touchstart event on element
          if (browser.touch) {
            element.addEventListener('touchstart', events, browser.passiveEvents ? {
              passive: true
            } : false);
          }

          if (options.draggable) {
            element.addEventListener('mousedown', events, false);
          }

          if (browser.transitions) {
            element.addEventListener('webkitTransitionEnd', events, false);
            element.addEventListener('msTransitionEnd', events, false);
            element.addEventListener('oTransitionEnd', events, false);
            element.addEventListener('otransitionend', events, false);
            element.addEventListener('transitionend', events, false);
          } // set resize event on window


          root.addEventListener('resize', events, false);
        } else {
          root.onresize = throttledSetup; // to play nice with old IE
        }
      } // clone nodes when there is only two slides


      function cloneNode(el) {
        var clone = el.cloneNode(true);
        element.appendChild(clone); // tag these slides as clones (to remove them on kill)

        clone.setAttribute('data-cloned', true); // Remove id from element

        clone.removeAttribute('id');
      }

      function setup(opts) {
        // Overwrite options if necessary
        if (opts != null) {
          for (var prop in opts) {
            options[prop] = opts[prop];
          }
        } // cache slides


        slides = element.children;
        length = slides.length; // slides length correction, minus cloned slides

        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-cloned')) length--;
        } // set continuous to false if only one slide


        if (slides.length < 2) {
          options.continuous = false;
        } // special case if two slides


        if (browser.transitions && options.continuous && slides.length < 3) {
          cloneNode(slides[0]);
          cloneNode(slides[1]);
          slides = element.children;
        } // adjust style on rtl


        if ('right' === slideDir) {
          for (var j = 0; j < slides.length; j++) {
            slides[j].style.float = 'right';
          }
        } // create an array to store current positions of each slide


        slidePos = new Array(slides.length); // determine width of each slide

        width = container.getBoundingClientRect().width || container.offsetWidth;
        element.style.width = slides.length * width * 2 + 'px'; // stack elements

        var pos = slides.length;

        while (pos--) {
          var slide = slides[pos];
          slide.style.width = width + 'px';
          slide.setAttribute('data-index', pos);

          if (browser.transitions) {
            slide.style[slideDir] = pos * -width + 'px';
            move(pos, index > pos ? -width : index < pos ? width : 0, 0);
          }
        } // reposition elements before and after index


        if (options.continuous && browser.transitions) {
          move(circle(index - 1), -width, 0);
          move(circle(index + 1), width, 0);
        }

        if (!browser.transitions) {
          element.style[slideDir] = index * -width + 'px';
        }

        container.style.visibility = 'visible'; // reinitialize events

        detachEvents();
        attachEvents();
      }

      function prev() {
        if (disabled) return;

        if (options.continuous) {
          slide(index - 1);
        } else if (index) {
          slide(index - 1);
        }
      }

      function next() {
        if (disabled) return;

        if (options.continuous) {
          slide(index + 1);
        } else if (index < slides.length - 1) {
          slide(index + 1);
        }
      }

      function runCallback(pos, index, dir) {
        if (options.callback) {
          options.callback(pos, index, dir);
        }
      }

      function runTransitionEnd(pos, index) {
        if (options.transitionEnd) {
          options.transitionEnd(pos, index);
        }
      }

      function runDragStart(pos, index) {
        if (options.dragStart) {
          options.dragStart(pos, index);
        }
      }

      function runDragEnd(pos, index) {
        if (options.dragEnd) {
          options.dragEnd(pos, index);
        }
      }

      function circle(index) {
        // a simple positive modulo using slides.length
        return (slides.length + index % slides.length) % slides.length;
      }

      function getPos() {
        // Fix for the clone issue in the event of 2 slides
        var currentIndex = index;

        if (currentIndex >= length) {
          currentIndex = currentIndex - length;
        }

        return currentIndex;
      }

      function slide(to, slideSpeed) {
        // ensure to is of type 'number'
        to = typeof to !== 'number' ? parseInt(to, 10) : to; // do nothing if already on requested slide

        if (index === to) return;

        if (browser.transitions) {
          var direction = Math.abs(index - to) / (index - to); // 1: backward, -1: forward
          // get the actual position of the slide

          if (options.continuous) {
            var natural_direction = direction;
            direction = -slidePos[circle(to)] / width; // if going forward but to < index, use to = slides.length + to
            // if going backward but to > index, use to = -slides.length + to

            if (direction !== natural_direction) {
              to = -direction * slides.length + to;
            }
          }

          var diff = Math.abs(index - to) - 1; // move all the slides between index and to in the right direction

          while (diff--) {
            move(circle((to > index ? to : index) - diff - 1), width * direction, 0);
          }

          to = circle(to);
          move(index, width * direction, slideSpeed || speed);
          move(to, 0, slideSpeed || speed);

          if (options.continuous) {
            // we need to get the next in place
            move(circle(to - direction), -(width * direction), 0);
          }
        } else {
          to = circle(to);
          animate(index * -width, to * -width, slideSpeed || speed); // no fallback for a circular continuous if the browser does not accept transitions
        }

        index = to;
        offloadFn(function () {
          runCallback(getPos(), slides[index], direction);
        });
      }

      function move(index, dist, speed) {
        translate(index, dist, speed);
        slidePos[index] = dist;
      }

      function translate(index, dist, speed) {
        var slide = slides[index];
        var style = slide && slide.style;
        if (!style) return;
        style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration = speed + 'ms';
        style.webkitTransform = style.msTransform = style.MozTransform = style.OTransform = style.transform = 'translateX(' + dist + 'px)';
      }

      function animate(from, to, speed) {
        // if not an animation, just reposition
        if (!speed) {
          element.style[slideDir] = to + 'px';
          return;
        }

        var start = +new Date();
        var timer = setInterval(function () {
          var timeElap = +new Date() - start;

          if (timeElap > speed) {
            element.style[slideDir] = to + 'px';
            if (delay || options.autoRestart) restart();
            runTransitionEnd(getPos(), slides[index]);
            clearInterval(timer);
            return;
          }

          element.style[slideDir] = (to - from) * (Math.floor(timeElap / speed * 100) / 100) + from + 'px';
        }, 4);
      }

      function begin() {
        delay = options.auto || 0;
        if (delay) interval = setTimeout(next, delay);
      }

      function stop() {
        delay = 0;
        clearTimeout(interval);
      }

      function restart() {
        stop();
        begin();
      }

      function disable() {
        stop();
        disabled = true;
      }

      function enable() {
        disabled = false;
        restart();
      }

      function isMouseEvent(e) {
        return /^mouse/.test(e.type);
      }

      function kill() {
        // cancel slideshow
        stop(); // remove inline styles

        container.style.visibility = ''; // reset element

        element.style.width = '';
        element.style[slideDir] = ''; // reset slides

        var pos = slides.length;

        while (pos--) {
          if (browser.transitions) {
            translate(pos, 0, 0);
          }

          var slide = slides[pos]; // if the slide is tagged as clone, remove it

          if (slide.getAttribute('data-cloned')) {
            var _parent = slide.parentElement;

            _parent.removeChild(slide);
          } // remove styles


          slide.style.width = '';
          slide.style[slideDir] = '';
          slide.style.webkitTransitionDuration = slide.style.MozTransitionDuration = slide.style.msTransitionDuration = slide.style.OTransitionDuration = slide.style.transitionDuration = '';
          slide.style.webkitTransform = slide.style.msTransform = slide.style.MozTransform = slide.style.OTransform = ''; // remove custom attributes (?)
          // slide.removeAttribute('data-index');
        } // remove all events


        detachEvents(); // remove throttled function timeout

        throttledSetup.cancel();
      }
    }

    if (root.jQuery || root.Zepto) {
      (function ($) {
        $.fn.Swipe = function (params) {
          return this.each(function () {
            $(this).data('Swipe', new Swipe($(this)[0], params));
          });
        };
      })(root.jQuery || root.Zepto);
    }

    return Swipe;
  });
});

var GooCarousel = {
  name: 'goo-carousel',
  props: {
    slideWrap: {
      type: String,
      default: '.goo-carousel-slide-wrap'
    },
    continuous: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: Number
    }
  },

  data() {
    return {
      swipe: null,
      activeIndex: 0
    };
  },

  render() {
    return this.$scopedSlots.default({
      activeIndex: this.activeIndex,
      next: this.next,
      hasNext: this.hasNext,
      previous: this.previous,
      hasPrevious: this.hasPrevious,
      goTo: this.goTo
    });
  },

  watch: {
    activeIndex(activeIndex) {
      this.swipe.slide(activeIndex, 300);
    }

  },
  computed: {
    loaded() {
      return this.swipe !== null;
    },

    hasNext() {
      if (!this.loaded) {
        return false;
      }

      if (this.continuous) {
        return true;
      }

      return this.activeIndex < this.swipe.getNumSlides() - 1;
    },

    hasPrevious() {
      if (!this.loaded) {
        return false;
      }

      if (this.continuous) {
        return true;
      }

      return this.activeIndex > 0;
    }

  },
  methods: {
    next() {
      this.swipe.next();
    },

    previous() {
      this.swipe.prev();
    },

    goTo(index) {
      this.activeIndex = index;
    },

    onChangeSlide(index, element) {
      this.activeIndex = index;
    },

    makeSwipe() {
      if (this.swipe == null) {
        this.swipe = new swipe(this.$el.querySelector(this.slideWrap), {
          callback: this.onChangeSlide,
          continuous: this.continuous,
          disableScroll: false
        });
      }
    },

    onResize: debounce(function () {
      if (this.needsSwipe()) {
        this.makeSwipe();
      } else {
        if (this.swipe !== null) {
          this.swipe.kill();
          this.swipe = null;
        }
      }
    }, 100),

    needsSwipe() {
      if (!this.maxWidth) {
        return true;
      }

      return window.innerWidth < this.maxWidth;
    }

  },

  destroyed() {
    if (this.maxWidth) {
      window.removeEventListener('resize', this.onResize);
    }
  },

  mounted() {
    if (this.needsSwipe()) {
      this.makeSwipe();
    }

    if (this.maxWidth) {
      window.addEventListener('resize', this.onResize);
    }
  }

};

const Plugin$4 = {
  install(Vue) {
    registerComponent(Vue, GooCarousel);
  }

};

//
//
//
//
//
//
//
var script$4 = {
  name: "goo-checklist-item",
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'check'
    }
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    { staticClass: "goo-checklist-item" },
    [
      _c("goo-icon", { staticClass: "is-primary", attrs: { name: _vm.icon } }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.title))])
    ],
    1
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

//
var script$5 = {
  name: "goo-checklist",
  components: {
    GooChecklistItem: __vue_component__$4
  },
  props: {
    items: {
      type: Array,
      default: []
    },
    icon: {
      type: String,
      default: 'check'
    }
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ul",
    { staticClass: "goo-checklist" },
    _vm._l(_vm.items, function(item) {
      return _c("goo-checklist-item", {
        key: item,
        attrs: { icon: _vm.icon, title: item }
      })
    }),
    1
  )
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$5 = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$5);
    registerComponent(Vue, __vue_component__$4);
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$6 = {
  name: "goo-circular-progress",
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    max: {
      type: [Number, String],
      default: 100
    },
    animated: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    strokeDashArray() {
      return [this.percentage, 100].join(',');
    },

    percentage() {
      return this.value / this.max * 100;
    }

  },
  watch: {
    value() {
      this.$el.classList.remove('is-animated');
    }

  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      staticClass: "goo-circular-progress",
      class: { "is-animated": _vm.animated },
      attrs: { viewBox: "0 0 36 36", width: "180" }
    },
    [
      _c("path", {
        staticClass: "goo-round-progress-track",
        attrs: {
          d:
            "M18 2.0845\n  a 15.9155 15.9155 0 0 1 0 31.831\n  a 15.9155 15.9155 0 0 1 0 -31.831",
          fill: "none",
          stroke: "#DCDCDC",
          "stroke-width": "3",
          "stroke-dasharray": "100, 100"
        }
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "goo-circular-progress-arc",
        attrs: {
          d:
            "M18 2.0845\n  a 15.9155 15.9155 0 0 1 0 31.831\n  a 15.9155 15.9155 0 0 1 0 -31.831",
          fill: "none",
          stroke: "#444",
          "stroke-width": "3",
          "stroke-dasharray": _vm.strokeDashArray
        }
      })
    ]
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$6 = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$6);
  }

};

//
//
//
//
//
//
var script$7 = {
  name: "goo-close-button"
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          staticClass: "goo-close-button",
          attrs: { type: "button", "aria-label": "close" }
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_c("goo-icon", { attrs: { name: "close", width: "22" } })],
    1
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$7 = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$7);
  }

};

function pick(obj, keys) {
  return keys.map(k => k in obj ? {
    [k]: obj[k]
  } : {}).reduce((res, o) => Object.assign(res, o), {});
}

//
const requiredKeys = ['value', 'valueText', 'label'];
var script$8 = {
  name: "goo-custom-radio",
  mixins: [UniqueId],
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true,

      validate(options) {
        return options.reduce((valid, next) => valid && pick(next, requiredKeys).length === requiredKeys.length, true);
      }

    },
    otherLabel: {
      type: String,
      default: "Other"
    }
  },

  data() {
    return {
      radioValue: this.computeRadioValue(this.value),
      other: {
        value: this.computeOtherValue(this.value)
      }
    };
  },

  watch: {
    value(val) {
      this.radioValue = this.computeRadioValue(val);
      this.other.value = this.computeOtherValue(val);
    },

    radioValue() {
      this.other.value = null;
      this.$emit('input', this.currentValue);
    },

    other: {
      deep: true,

      handler() {
        this.$emit('input', this.currentValue);
      }

    }
  },
  computed: {
    otherSelected() {
      return this.isOther(this.radioValue);
    },

    currentValue() {
      return this.otherSelected ? this.other.value : this.radioValue;
    }

  },
  methods: {
    computeOptionValues() {
      return this.options.map(option => option.value);
    },

    onInput() {
      this.$emit('input', this.currentValue);
    },

    hasValue(value) {
      return this.computeOptionValues().includes(value);
    },

    computeRadioValue(value) {
      return this.hasValue(this.value) ? value : 'other';
    },

    computeOtherValue(value) {
      return this.isOther(this.computeRadioValue(value)) ? value : null;
    },

    isOther(value) {
      return value === 'other';
    }

  }
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-custom-radio" }, [
    _c(
      "div",
      { staticClass: "goo-custom-radio-options" },
      _vm._l(_vm.options, function(timeSlot, index) {
        return _c("div", { staticClass: "goo-custom-radio-option" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.radioValue,
                expression: "radioValue"
              }
            ],
            staticClass: "goo-custom-radio-input is-sr-only",
            attrs: { type: "radio", name: "custom", id: _vm.keyedId(index) },
            domProps: {
              value: timeSlot.value,
              checked: _vm._q(_vm.radioValue, timeSlot.value)
            },
            on: {
              change: function($event) {
                _vm.radioValue = timeSlot.value;
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "goo-custom-radio-label",
              attrs: { for: _vm.keyedId(index) }
            },
            [
              _c("span", { staticClass: "body-1 has-text-bold" }, [
                _vm._v(_vm._s(timeSlot.valueText))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "body-3" }, [
                _vm._v(_vm._s(timeSlot.label))
              ])
            ]
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "goo-custom-radio-option",
        class: { "is-sr-only": _vm.otherSelected }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.radioValue,
              expression: "radioValue"
            }
          ],
          staticClass:
            "goo-custom-radio-input goo-custom-radio-input-other is-sr-only",
          attrs: {
            type: "radio",
            name: "custom",
            id: _vm.keyedId("other"),
            value: "other"
          },
          domProps: { checked: _vm._q(_vm.radioValue, "other") },
          on: {
            change: function($event) {
              _vm.radioValue = "other";
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "goo-custom-radio-label-other goo-link is-primary",
            attrs: { for: _vm.keyedId("other") }
          },
          [_vm._v(_vm._s(_vm.otherLabel))]
        )
      ]
    ),
    _vm._v(" "),
    _vm.otherSelected
      ? _c(
          "div",
          { staticClass: "goo-custom-radio-option" },
          [_vm._t("default", null, { other: _vm.other })],
          2
        )
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$8 = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$8);
  }

};

//
const MaskParts = [{
  characters: "MM",
  start: 0,
  end: 2,
  minVal: 1,
  maxVal: 12
}, {
  characters: "DD",
  start: 3,
  end: 5,
  minVal: 1,
  maxVal: 31
}, {
  characters: "YYYY",
  start: 6,
  end: 10,
  minVal: 1,
  maxVal: 9999
}];
const ValueDateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/;
const DisplayDateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/;
const KEYS = {
  BACKSPACE: 8,
  TAB: 9,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40
};
var script$9 = {
  name: "goo-date",
  inheritAttrs: false,
  props: {
    value: String
  },

  data() {
    return {
      inputValue: null,
      maskSelectionIndex: 0,
      charactersTypedInRange: 0,
      keyHandlers: {
        [KEYS.TAB]: this.tab,
        [KEYS.ARROW_RIGHT]: this.selectNext,
        [KEYS.ARROW_LEFT]: this.selectPrevious,
        [KEYS.ARROW_UP]: this.increment,
        [KEYS.ARROW_DOWN]: this.decrement,
        [KEYS.BACKSPACE]: this.clearRange
      }
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: "setInputValue"
    },

    maskSelectionIndex() {
      this.charactersTypedInRange = 0;
      this.reselect();
    }

  },
  computed: {
    listeners() {
      const {
        focus,
        keydown,
        mousedown,
        select,
        ...listeners
      } = this.$listeners;
      return listeners;
    },

    attrs() {
      const {
        autocomplete,
        type,
        ...attrs
      } = this.$attrs;
      return attrs;
    },

    isMobile() {
      return window.navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i);
    },

    emptyMask() {
      return MaskParts.map(part => part.characters).join("/");
    },

    currentRange() {
      return MaskParts[this.maskSelectionIndex];
    },

    hasPreviousRange() {
      return this.maskSelectionIndex > 0;
    },

    hasNextRange() {
      return this.maskSelectionIndex < MaskParts.length - 1;
    },

    selectionRangeStart() {
      return this.currentRange.start;
    },

    selectionRangeEnd() {
      return this.currentRange.end;
    },

    charactersInRange() {
      return this.inputValue.substring(this.selectionRangeStart, this.selectionRangeEnd);
    },

    minValueOfRange() {
      return this.currentRange.minVal;
    },

    maxValueOfRange() {
      return this.currentRange.maxVal;
    },

    placeholderForRange() {
      return this.currentRange.characters;
    },

    lengthOfRange() {
      return this.currentRange.characters.length;
    },

    hasCharactersLeft() {
      return this.charactersTypedInRange < this.lengthOfRange;
    },

    canAddDigit() {
      return parseInt(this.charactersInRange) * 10 <= this.maxValueOfRange;
    },

    shouldAutoAdvance() {
      return !this.hasCharactersLeft || !this.canAddDigit;
    }

  },
  methods: {
    onMouseDown(event) {
      event.stopPropagation = true; //Wait for it... some browsers down't update the cursor position right away

      setTimeout(this.setSelectionByCaretPosition, 0);
    },

    onFocus() {
      this.charactersTypedInRange = 0; //Wait for it...some browsers have updated the cursor to select the whole input range by now

      setTimeout(this.reselect, 0);
    },

    onKeydown(event) {
      const key = event.keyCode || event.which;
      const handler = this.keyHandlers[key];

      if (typeof handler === "function") {
        if (this.interceptedKeyEvent(handler, event, key)) {
          event.preventDefault();
        }

        return;
      }

      this.handleOtherKey(key, event);
    },

    interceptedKeyEvent(handler, event, key) {
      return handler.apply(this, [event, key]) !== false;
    },

    hasModifierKeyPressed(event) {
      return event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
    },

    //Begin key handlers
    tab(event) {
      if (event.shiftKey) {
        return this.tabBack(event);
      } else {
        return this.tabForward(event);
      }
    },

    tabForward() {
      if (!this.hasNextRange) {
        return false;
      }

      this.selectNext();
    },

    tabBack() {
      if (!this.hasPreviousRange) {
        return false;
      }

      this.selectPrevious();
    },

    selectNext() {
      if (this.hasNextRange) {
        this.maskSelectionIndex++;
      }
    },

    selectPrevious() {
      if (this.hasPreviousRange) {
        this.maskSelectionIndex--;
      }
    },

    increment() {
      this.onDelta(1);
    },

    decrement() {
      this.onDelta(-1);
    },

    onDelta(delta) {
      const numberValue = parseInt(this.charactersInRange) + delta;

      if (!isNaN(numberValue) && numberValue > this.minValueOfRange) {
        this.onNumber(numberValue);
      } else {
        this.onNumber(this.minValueOfRange);
      }

      this.reselect();
    },

    clearRange() {
      this.replaceCharactersInSelection(this.placeholderForRange);
    },

    handleOtherKey(key, event) {
      if (this.hasModifierKeyPressed(event)) {
        return false;
      }

      event.preventDefault();
      this.onCharacterKey(String.fromCharCode(key));
    },

    // End key handlers
    setSelectionByCaretPosition() {
      const caratPosition = this.$refs.input.selectionStart;
      this.maskSelectionIndex = this.selectionIndexForSelection(caratPosition);
      this.reselect();
    },

    reselect() {
      this.$nextTick(() => {
        this.$refs.input.setSelectionRange(this.selectionRangeStart, this.selectionRangeEnd);
      });
    },

    selectionIndexForSelection(selectionStart) {
      return MaskParts.findIndex(range => {
        return selectionStart >= range.start && selectionStart <= range.end;
      }) || 0;
    },

    onCharacterKey(char) {
      if (!/[0-9]|\./.test(char)) {
        return;
      }

      this.onNumber(parseInt(char));
      this.charactersTypedInRange++;
      this.autoAdvance();
    },

    onNumber(number) {
      let updatedCharacters = this.charactersTypedInRange > 0 ? this.charactersInRange : this.placeholderForRange;
      updatedCharacters = this.zeroPad(updatedCharacters);
      updatedCharacters = this.shiftInCharacter(updatedCharacters, number.toString(), this.lengthOfRange);
      this.updateCharactersInSelection(updatedCharacters);
    },

    zeroPad(characters) {
      return characters.replace(/\D/g, "0");
    },

    shiftInCharacter(characters, character, length) {
      characters += character;
      return characters.slice(-length);
    },

    updateCharactersInSelection(characters) {
      if (parseInt(characters) >= this.maxValueOfRange) {
        characters = this.maxValueOfRange.toString();
      }

      this.replaceCharactersInSelection(characters);
    },

    autoAdvance() {
      if (this.shouldAutoAdvance && this.hasNextRange) {
        this.selectNext();
      }
    },

    replaceCharactersInSelection(characters) {
      const value = this.inputValue;
      this.inputValue = value.substr(0, this.selectionRangeStart) + characters + value.substr(this.selectionRangeEnd);
      this.reselect();
      this.$emit("input", this.toISODate(this.inputValue));
    },

    setInputValue(value) {
      this.inputValue = this.toDisplayValue(value);
    },

    toDisplayValue(dateValue) {
      if (ValueDateRegex.test(dateValue)) {
        let parts = dateValue.split("-");
        return `${parts[1]}/${parts[2]}/${parts[0]}`;
      }

      if (!this.inputValue) {
        return this.emptyMask;
      }

      return this.inputValue;
    },

    toISODate(dateValue) {
      if (DisplayDateRegex.test(dateValue)) {
        let parts = dateValue.split("/");
        const isoString = `${parts[2]}-${parts[0]}-${parts[1]}`;

        if (this.isValidISODateString(isoString)) {
          return isoString;
        }
      }

      return "";
    },

    isValidISODateString(isoString) {
      const testDate = parse(isoString);
      const parts = isoString.split("-");
      const yearMatches = testDate.getFullYear() === parseInt(parts[0]);
      const monthMatches = testDate.getMonth() === parseInt(parts[1]) - 1;
      const dayMatches = testDate.getDate() === parseInt(parts[2]);
      return !isNaN(testDate.getTime()) && yearMatches && monthMatches && dayMatches;
    },

    onNativeInput(event) {
      this.$emit("input", event.target.value);
    }

  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-date" }, [
    !_vm.isMobile
      ? _c(
          "input",
          _vm._g(
            _vm._b(
              {
                ref: "input",
                staticClass: "goo-input",
                attrs: { autocomplete: "off", type: "text" },
                domProps: { value: _vm.inputValue },
                on: {
                  focus: _vm.onFocus,
                  keydown: _vm.onKeydown,
                  mousedown: _vm.onMouseDown,
                  select: _vm.reselect
                }
              },
              "input",
              _vm.attrs,
              false
            ),
            _vm.listeners
          )
        )
      : _c(
          "input",
          _vm._b(
            {
              staticClass: "goo-input",
              attrs: { type: "date" },
              domProps: { value: _vm.value },
              on: { input: _vm.onNativeInput }
            },
            "input",
            _vm.$attrs,
            false
          )
        )
  ])
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = undefined;
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$9 = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$9);
  }

};

//
//
//
//
//
//
var script$a = {
  name: "goo-modal",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    focusTrap: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      lastScrollTop: null
    };
  },

  watch: {
    active(active) {
      this.onEnabled(active);
    }

  },
  computed: {
    modalClassName() {
      return this.active ? "is-active" : "";
    },

    focusableElements() {
      let focusableElements = this.$el.querySelectorAll("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]");
      return Array.prototype.slice.call(focusableElements);
    },

    firstFocusableElement() {
      if (this.focusableElements.length == 0) {
        return null;
      }

      return this.focusableElements[0];
    },

    lastFocusableElement() {
      return this.focusableElements[this.focusableElements.length - 1];
    }

  },
  methods: {
    onKeyDown(event) {
      let key = event.key || event.keyCode;

      if (key === "Escape" || key === "Esc" || key === 27) {
        this.close();
      }

      if (this.focusTrap && (key === "Tab" || key === 9)) {
        if (event.shiftKey) {
          this.onBackwardTab(event);
        } else {
          this.onForwardTab(event);
        }
      }
    },

    onForwardTab(event) {
      if (document.activeElement === this.lastFocusableElement) {
        event.preventDefault();
        this.firstFocusableElement.focus();
      }
    },

    onBackwardTab(event) {
      if (document.activeElement === this.firstFocusableElement) {
        event.preventDefault();
        this.lastFocusableElement.focus();
      }
    },

    onClick() {
      this.close();
    },

    close() {
      if (this.active) {
        this.$emit("close");
      }
    },

    preventBodyScrolling(enabled) {
      if (enabled) {
        document.body.classList.add("goo-modal-active");
      } else {
        document.body.classList.remove("goo-modal-active");
      }
    },

    allowClickOutside(enabled) {
      if (this.$slots.default) {
        if (enabled) {
          this.$slots.default[0].elm.addEventListener('click', this.onClickOutside);
        } else {
          this.$slots.default[0].elm.removeEventListener('click', this.onClickOutside);
        }
      }
    },

    onClickOutside(event) {
      event.stopPropagation();
    },

    onEnabled(enabled) {
      this.preventBodyScrolling(enabled);
      this.$nextTick(() => {
        this.allowClickOutside(enabled);
      });
    }

  },

  mounted() {
    document.addEventListener("keydown", this.onKeyDown);

    if (this.active) {
      this.onEnabled(this.active);
    }
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown);
    this.onEnabled(false);
  }

};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: ["goo-modal", _vm.modalClassName], on: { click: _vm.onClick } },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$a = undefined;
  /* scoped */
  const __vue_scope_id__$a = undefined;
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$a = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$a);
  }

};

//
var script$b = {
  name: "goo-dialog",
  components: {
    GooModal: Plugin$a
  },
  props: {
    title: String,
    message: String,
    type: {
      type: String,
      default: "is-primary"
    },
    hasIcon: Boolean,
    icon: String,
    confirmText: {
      type: String,
      default: "OK"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    canCancel: {
      type: Boolean,
      default: true
    },
    onConfirm: {
      type: Function,
      default: () => {}
    },
    onCancel: {
      type: Function,
      default: () => {}
    },
    customClass: String,
    stackedButtons: Boolean
  },

  data() {
    return {
      modalActive: false
    };
  },

  computed: {
    iconType() {
      switch (this.type) {
        case "is-primary":
          return "circle-check-outline";

        case "is-error":
          return "circle-error";

        default:
          return null;
      }
    },

    iconName() {
      return this.icon || this.iconType;
    }

  },
  methods: {
    confirm() {
      this.onConfirm();
      this.close();
    },

    cancel() {
      this.onCancel();
      this.close();
    },

    close() {
      this.modalActive = false;
      this.$nextTick(() => {
        this.$destroy();
        this.$el.remove();
      });
    }

  },

  beforeMount() {
    // Add to body
    if (typeof window !== "undefined") {
      this.$nextTick(() => {
        document.body.appendChild(this.$el);
      });
    }
  },

  mounted() {
    this.modalActive = true;
  }

};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("goo-modal", { attrs: { active: _vm.modalActive } }, [
    _c("div", { staticClass: "goo-dialog is-alert", class: _vm.customClass }, [
      _c("header", [
        _vm.hasIcon
          ? _c(
              "div",
              { staticClass: "goo-dialog-image has-text-centered" },
              [
                _c("goo-icon", {
                  attrs: { name: _vm.iconName, type: _vm.type, width: "60" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.title
          ? _c("div", { staticClass: "goo-dialog-heading" }, [
              _c("h3", { staticClass: "heading-3" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.message
        ? _c("div", { staticClass: "goo-dialog-body" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("footer", [
        _vm.stackedButtons
          ? _c("div", { staticClass: "goo-button-group" }, [
              _c(
                "button",
                {
                  staticClass: "goo-button is-primary is-full-width",
                  attrs: { type: "button" },
                  on: { click: _vm.confirm }
                },
                [_vm._v(_vm._s(_vm.confirmText) + "\n                ")]
              ),
              _vm._v(" "),
              _vm.canCancel
                ? _c(
                    "button",
                    {
                      staticClass:
                        "goo-button is-primary is-outlined is-full-width",
                      attrs: { type: "button" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(_vm._s(_vm.cancelText) + "\n                ")]
                  )
                : _vm._e()
            ])
          : _c("div", { staticClass: "goo-button-group is-equal-width" }, [
              _vm.canCancel
                ? _c(
                    "button",
                    {
                      staticClass: "goo-button is-primary is-outlined",
                      attrs: { type: "button" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(_vm._s(_vm.cancelText) + "\n                ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "goo-button is-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.confirm }
                },
                [_vm._v(_vm._s(_vm.confirmText) + "\n                ")]
              )
            ])
      ])
    ])
  ])
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = undefined;
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

function openDialog(propsData) {
  const vm = typeof window !== "undefined" && window.Vue ? window.Vue : Vue;
  const GooDialogComponent = vm.extend(__vue_component__$b);
  return new GooDialogComponent({
    el: document.createElement("div"),
    propsData
  });
}

const ProgrammaticDialog = {
  alert(params) {
    if (typeof params === "string") {
      params = {
        title: params
      };
    }

    const defaultParams = {
      canCancel: false,
      customClass: "has-text-centered"
    };
    const propsData = { ...defaultParams,
      ...params
    };
    return openDialog(propsData);
  },

  confirm(params) {
    return openDialog(params);
  }

};
const Plugin$b = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$b);
    registerInstanceComponent(Vue, "dialog", ProgrammaticDialog);
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$c = {
  name: "goo-dropdown",
  props: {
    hoverable: {
      type: Boolean,
      default: false
    },
    hideDelay: {
      type: Number,
      default: 200
    },
    position: {
      type: String,

      validator(value) {
        return ["is-left", "is-right", "is-up"].indexOf(value) > -1;
      }

    }
  },

  data() {
    return {
      active: false,
      selected: null,
      hideTimer: null
    };
  },

  computed: {
    dropdownClass() {
      return [this.position, {
        "is-active": this.active
      }];
    }

  },
  methods: {
    toggle() {
      this.active = !this.active;
    },

    selectItem(item) {
      this.active = false;
    },

    onToggleClick() {
      this.toggle();
    },

    onMouseOver() {
      if (!this.hoverable) {
        return;
      }

      this.active = true;
      clearTimeout(this.hideTimer);
    },

    onMouseOut() {
      if (!this.hoverable) {
        return;
      }

      this.hideTimer = setTimeout(() => {
        this.active = false;
      }, this.hideDelay);
    },

    onFocusOut(event) {
      if (event.relatedTarget && !this.$el.contains(event.relatedTarget)) {
        this.active = false;
      }
    },

    onDocumentClick(event) {
      if (!this.$el.contains(event.target)) {
        this.active = false;
      }
    }

  },

  created() {
    document.addEventListener("click", this.onDocumentClick);
  },

  destroyed() {
    document.removeEventListener("click", this.onDocumentClick);
  }

};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "goo-dropdown",
      class: _vm.dropdownClass,
      on: {
        mouseenter: _vm.onMouseOver,
        mouseleave: _vm.onMouseOut,
        focusout: _vm.onFocusOut
      }
    },
    [
      _c(
        "div",
        {
          ref: "trigger",
          staticClass: "goo-dropdown-toggle",
          attrs: {
            role: "button",
            "aria-haspopup": "true",
            "aria-expanded": _vm.active
          },
          on: { click: _vm.onToggleClick }
        },
        [_vm._t("toggle")],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "goo-dropdown-menu" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active,
                expression: "active"
              }
            ],
            ref: "menu",
            staticClass: "goo-dropdown-menu",
            attrs: { "aria-hidden": !_vm.active }
          },
          [
            _c(
              "div",
              { staticClass: "goo-dropdown-content" },
              [_vm._t("default")],
              2
            )
          ]
        )
      ])
    ],
    1
  )
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  const __vue_inject_styles__$c = undefined;
  /* scoped */
  const __vue_scope_id__$c = undefined;
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
var script$d = {
  name: "goo-dropdown-item",
  methods: {
    onItemClick() {
      this.$parent.selectItem(this.value);
      this.$emit("click");
    }

  }
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "goo-dropdown-item",
      attrs: { tabindex: "0", role: "menuitem" },
      on: { click: _vm.onItemClick }
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  const __vue_inject_styles__$d = undefined;
  /* scoped */
  const __vue_scope_id__$d = undefined;
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$c = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$c);
    registerComponent(Vue, __vue_component__$d);
  }

};

//
var script$e = {
  name: "goo-error-dialog",
  components: {
    GooCloseButton: __vue_component__$7,
    GooModal: __vue_component__$a
  },

  data() {
    return {
      active: false,
      title: null,
      body: null,
      lastFocusedElement: null
    };
  },

  methods: {
    onClose() {
      this.close();
    },

    close() {
      this.active = false;
      this.$emit("close");
      this.$nextTick(() => {
        this.lastFocusedElement.focus();
      });
    },

    open(title, body) {
      this.lastFocusedElement = document.activeElement;
      this.title = title;
      this.body = body;
      this.active = true;
      this.$emit("open");
      this.$nextTick(() => {
        // TODO: We should be able to put the closeButton ref directly on the goo-close-button component but the ref is not available at the point this is called
        this.$refs.closeButton.querySelector("button").focus();
      });
    }

  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "goo-modal",
    { attrs: { active: _vm.active }, on: { close: _vm.onClose } },
    [
      _c(
        "div",
        {
          staticClass: "goo-dialog goo-error-dialog",
          attrs: {
            role: "alertdialog",
            "aria-labelledby": "error_title",
            "aria-describedby": "error_body"
          }
        },
        [
          _c(
            "div",
            { ref: "closeButton" },
            [_c("goo-close-button", { on: { click: _vm.onClose } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "goo-dialog-heading" },
            [
              _c("goo-icon", {
                staticClass: "is-error",
                attrs: { name: "circle-error", width: "60" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass: "goo-error-title heading-3",
              attrs: { id: "error_title" }
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "goo-error-body", attrs: { id: "error_body" } },
            [_vm._v(_vm._s(_vm.body))]
          )
        ]
      )
    ]
  )
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  const __vue_inject_styles__$e = undefined;
  /* scoped */
  const __vue_scope_id__$e = undefined;
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$d = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$e);
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$f = {
  name: "goo-header",
  props: {
    layoutStyle: {
      type: String,
      default: "opaque"
    },
    logoUrl: {
      type: String,
      default: "/"
    },
    compact: {
      type: Boolean
    },
    title: String
  },

  data() {
    return {
      mobileDropDownActive: false,
      dropDownTransitioning: false
    };
  },

  computed: {
    isTransparent() {
      return !this.mobileDropDownActive && !this.dropDownTransitioning && this.layoutStyle === "transparent";
    },

    hasMobileNav() {
      return !!this.$slots["mobile-nav"];
    },

    className() {
      return {
        "is-transparent": this.isTransparent,
        "is-open": this.mobileDropDownActive,
        "is-compact": this.compact
      };
    }

  },
  methods: {
    onNavToggleClick() {
      if (!this.mobileDropDownActive) {
        this.openNav();
      } else {
        this.closeNav();
      }
    },

    openNav() {
      this.mobileDropDownActive = true;
    },

    closeNav() {
      this.dropDownTransitioning = true;
      this.mobileDropDownActive = false;
    },

    onAfterDropDownClose() {
      this.dropDownTransitioning = false;
    },

    onDocumentClick(event) {
      if (this.$refs.mobileNav && this.clickedOnLink(this.$refs.mobileNav, event)) {
        this.closeNav();
      }
    },

    clickedOnLink(container, event) {
      let target = event.target;

      while (container.contains(target)) {
        if (target.tagName.toLowerCase() === "a") {
          // check if target is an anchor tag
          return true;
        }

        target = target.parentNode;
      }

      return false;
    },

    onLogoClick(e) {
      // FIXME: Ideally, we would use a router-link here but the header is used outside the router sometimes
      if (this.$router && this.isValidRoute(this.logoUrl)) {
        e.preventDefault();
        this.$router.push(this.logoUrl);
      }
    },

    isValidRoute(path) {
      const route = this.$router.resolve(path);
      return route.resolved.matched.length > 0;
    }

  },

  mounted() {
    document.addEventListener("click", this.onDocumentClick.bind(this));
  },

  destroyed() {
    document.removeEventListener("click", this.onDocumentClick.bind(this));
  }

};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "header",
    { staticClass: "goo-header", class: _vm.className },
    [
      _c(
        "div",
        { staticClass: "goo-header-nav" },
        [
          _c(
            "nav",
            { staticClass: "goo-header-logo" },
            [
              _vm._t("logo", [
                _c(
                  "a",
                  {
                    staticClass: "goo-logo is-desktop",
                    attrs: { href: _vm.logoUrl },
                    on: { click: _vm.onLogoClick }
                  },
                  [
                    _vm._t("desktop-logo", [
                      _c("goo-icon", {
                        staticClass: "icon",
                        attrs: { name: "logo", width: _vm.compact ? 90 : 150 }
                      })
                    ]),
                    _vm._v(" "),
                    _vm._t("title", [
                      _vm.title
                        ? _c("div", { staticClass: "goo-header-title" }, [
                            _c("span", { staticClass: "has-text-bold" }, [
                              _vm._v(_vm._s(_vm.title))
                            ])
                          ])
                        : _vm._e()
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.hasMobileNav
                  ? [
                      _c(
                        "a",
                        {
                          staticClass: "goo-logo is-mobile",
                          attrs: { href: _vm.logoUrl },
                          on: { click: _vm.onLogoClick }
                        },
                        [
                          _vm._t("mobile-logo", [
                            _c("goo-icon", {
                              staticClass: "icon",
                              attrs: {
                                name: "logo-stamp",
                                width: _vm.compact ? 24 : 40
                              }
                            })
                          ])
                        ],
                        2
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasMobileNav
                  ? [
                      _c(
                        "button",
                        {
                          staticClass:
                            "hide-large-up goo-header-nav-toggle icon-button is-mobile goo-logo",
                          attrs: { type: "button" },
                          on: { click: _vm.onNavToggleClick }
                        },
                        [
                          _vm._t("mobile-logo", [
                            _c("goo-icon", {
                              staticClass: "icon",
                              attrs: {
                                name: "logo-stamp",
                                width: _vm.compact ? 24 : 40
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("goo-icon", {
                            staticClass: "goo-header-nav-toggle-chevron icon",
                            attrs: { name: "chevron-down", width: "24" }
                          }),
                          _vm._v(" "),
                          !_vm.mobileDropDownActive
                            ? _c("span", { staticClass: "is-sr-only" }, [
                                _vm._v("Open Navigation")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mobileDropDownActive
                            ? _c("span", { staticClass: "is-sr-only" }, [
                                _vm._v("Close Navigation")
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  : _vm._e()
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "goo-header-main" },
            [
              _vm._t("left", null, {
                isTransparent: _vm.isTransparent,
                mobileDropDownActive: _vm.mobileDropDownActive
              }),
              _vm._v(" "),
              _vm._t("center", null, {
                isTransparent: _vm.isTransparent,
                mobileDropDownActive: _vm.mobileDropDownActive
              }),
              _vm._v(" "),
              _vm._t("right", null, {
                isTransparent: _vm.isTransparent,
                mobileDropDownActive: _vm.mobileDropDownActive
              }),
              _vm._v(" "),
              _vm._t("cta", null, {
                isTransparent: _vm.isTransparent,
                mobileDropDownActive: _vm.mobileDropDownActive
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: { name: "goo-header-mobile-nav-dropdown" },
              on: { afterLeave: _vm.onAfterDropDownClose }
            },
            [
              _vm.mobileDropDownActive
                ? _c("div", { staticClass: "goo-header-mobile-nav-dropdown" }, [
                    _c(
                      "nav",
                      {
                        ref: "mobileNav",
                        staticClass: "goo-header-mobile-nav"
                      },
                      [
                        _vm._t("mobile-nav", null, {
                          isTransparent: _vm.isTransparent,
                          onNavToggleClick: _vm.onNavToggleClick
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("bottom", null, { isTransparent: _vm.isTransparent })
    ],
    2
  )
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

  /* style */
  const __vue_inject_styles__$f = undefined;
  /* scoped */
  const __vue_scope_id__$f = undefined;
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    undefined,
    undefined,
    undefined
  );

var script$g = {
  name: "goo-header-item",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  functional: true,

  render(createElement, context) {
    context.data.staticClass = context.data.staticClass + ' goo-header-item';

    switch (context.props.item.type) {
      // FIXME: This is way too complicated and needs to be rethought.
      case 'link':
        context.data.attrs.href = context.props.item.url;
        context.data.attrs.target = context.props.item.target;
        context.data.attrs.rel = context.props.item.rel;
        return createElement('a', context.data, context.children);

      case 'route':
        context.data.attrs.to = context.props.item.route;
        context.data.attrs.target = context.props.item.target;
        context.data.attrs.exact = !!context.props.item.exact;
        return createElement('RouterLink', context.data, context.children);

      case 'accordion':
        context.data.attrs.title = context.props.item.text;
        return createElement("goo-accordion", { ...context.data,
          class: {},
          staticClass: 'is-nested goo-header-item'
        }, [createElement("template", {
          slot: "trigger"
        }, context.slots().default), createElement('template', {
          slot: 'default'
        }, context.props.item.items.map(item => {
          return createElement('goo-header-item', {
            props: {
              item
            },
            attrs: {},
            class: context.data.class,
            staticClass: context.data.staticClass
          }, [createElement('span', {}, [item.text])]);
        }))]);

      default:
        throw Error('unknown type');
    }
  }

};

/* script */
const __vue_script__$g = script$g;

/* template */

  /* style */
  const __vue_inject_styles__$g = undefined;
  /* scoped */
  const __vue_scope_id__$g = undefined;
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$e = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$f);
    registerComponent(Vue, __vue_component__$g);
  }

};

const getElementData = function (iconName, contextData, type) {
  const data = contextData;
  data.attrs = getAttributes(iconName, contextData.attrs);
  data.class = `${data.attrs.class} ${type}`;
  data.domProps = {
    innerHTML: getData(iconName).path
  };
  return data;
};

var GooIcon = {
  name: "goo-icon",
  props: {
    name: {
      type: String,
      required: true
    },
    type: String
  },
  functional: true,

  render(createElement, context) {
    return createElement("svg", getElementData(context.props.name, context.data, context.props.type));
  }

};

const Plugin$f = {
  install(Vue) {
    registerComponent(Vue, GooIcon);
  }

};

const GooWindow = new Vue({
  name: "goo-window",

  data() {
    return {
      scrollY: window.scrollY,
      scrollX: window.scrollX,
      width: this.getWindowWidth(),
      height: this.getWindowHeight()
    };
  },

  methods: {
    onScroll: debounce(function () {
      this.update();
    }, 10),
    onResize: debounce(function () {
      this.update();
    }, 10),

    getWindowHeight() {
      return window.innerHeight || document.documentElement.clientHeight;
    },

    getWindowWidth() {
      return window.innerWidth || document.documentElement.clientWidth;
    },

    update() {
      this.scrollY = window.scrollY;
      this.scrollX = window.scrollX;
      this.width = this.getWindowWidth();
      this.height = this.getWindowHeight();
    }

  },

  created() {
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);
  }

});

var GooInViewport = {
  name: "goo-in-viewport",
  props: {
    watchElement: {
      type: String,
      required: true
    },
    offset: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      element: null,
      loaded: false,
      inViewport: false,
      wasInViewport: false
    };
  },

  render() {
    return this.$scopedSlots.default({
      inViewport: this.inViewport,
      loaded: this.loaded,
      wasInViewport: this.wasInViewport
    });
  },

  computed: {
    scrollY() {
      return GooWindow.scrollY;
    },

    windowWidth() {
      return GooWindow.width;
    },

    windowHeight() {
      return GooWindow.height;
    }

  },
  watch: {
    scrollY() {
      this.update();
    },

    windowWidth() {
      this.update();
    },

    windowHeight() {
      this.update();
    },

    inViewport(viewPort) {
      if (viewPort) {
        this.wasInViewport = true;
      }
    }

  },
  methods: {
    update() {
      this.loaded = true;

      if (this.element) {
        this.inViewport = this.elementIsVisible(this.element);
      }
    },

    elementIsVisible(element) {
      let rect = element.getBoundingClientRect();
      let windowHeight = window.innerHeight || document.documentElement.clientHeight;
      let top = rect.top - this.offset;
      return top <= windowHeight && top + rect.height >= 0;
    }

  },

  mounted() {
    this.$nextTick(() => {
      this.element = document.querySelector(this.watchElement);
      this.update();
    });
  }

};

const Plugin$g = {
  install(Vue) {
    registerComponent(Vue, GooInViewport);
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$h = {
  name: "goo-increment",
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: Number.MIN_SAFE_INTEGER
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    step: {
      type: Number,
      default: 1
    },
    formatted: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      number: this.value
    };
  },

  watch: {
    number() {
      this.$emit('input', this.number);
    },

    value(value) {
      this.number = value;
    }

  },
  computed: {
    formattedNumber() {
      if (this.formatted) {
        return this.formatted;
      }

      return this.number;
    }

  },
  methods: {
    onKeyDown(event) {
      let key = event.key || event.keyCode;

      switch (key) {
        case 40:
        case "ArrowDown":
          event.stopPropagation();
          this.decrement();
          break;

        case 38:
        case "ArrowUp":
          event.stopPropagation();
          this.increment();
          break;

        case 27:
        case "Escape":
          this.$el.blur();
          break;
      }
    },

    onDecrementClick() {
      this.decrement();
    },

    decrement() {
      if (this.number - this.step >= this.min) {
        this.number -= this.step;
      }
    },

    onIncrementClick() {
      this.increment();
    },

    increment() {
      if (this.number + this.step <= this.max) {
        this.number += this.step;
      }
    }

  },

  mounted() {
    this.$el.addEventListener('keydown', this.onKeyDown);
  },

  destroyed() {
    this.$el.removeEventListener('keydown', this.onKeyDown);
  }

};

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "goo-increment",
      attrs: {
        tabindex: "0",
        "aria-valuemin": _vm.min,
        "aria-valuemax": _vm.max,
        "aria-valuenow": _vm.number,
        "aria-valuetext": _vm.formattedNumber,
        role: "slider"
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "icon-button goo-increment-button",
          attrs: { type: "button", tabindex: "-1" },
          on: {
            click: function($event) {
              $event.preventDefault();
              return _vm.onDecrementClick($event)
            }
          }
        },
        [
          _c("goo-icon", { attrs: { name: "circle-minus", width: "32" } }),
          _vm._v(" "),
          _c("span", { staticClass: "is-sr-only" }, [_vm._v("Decrement")])
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "goo-increment-number" }, [
        _vm._v(_vm._s(_vm.formattedNumber))
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "icon-button goo-increment-button",
          attrs: { type: "button", tabindex: "-1" },
          on: {
            click: function($event) {
              $event.preventDefault();
              return _vm.onIncrementClick($event)
            }
          }
        },
        [
          _c("goo-icon", { attrs: { name: "circle-plus", width: "32" } }),
          _vm._v(" "),
          _c("span", { staticClass: "is-sr-only" }, [_vm._v("Decrement")])
        ],
        1
      )
    ]
  )
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  const __vue_inject_styles__$h = undefined;
  /* scoped */
  const __vue_scope_id__$h = undefined;
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$h = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$h);
  }

};

//
var script$i = {
  name: "goo-lightbox",
  components: {
    GooCloseButton: __vue_component__$7,
    GooModal: __vue_component__$a
  },

  data() {
    return {
      active: false
    };
  },

  methods: {
    toggle() {
      this.active = true;
    },

    close() {
      this.active = false;
    }

  }
};

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "goo-lightbox" },
    [
      _c(
        "div",
        {
          ref: "trigger",
          staticClass: "goo-lightbox-trigger",
          attrs: { role: "button" },
          on: { click: _vm.toggle }
        },
        [_vm._t("trigger")],
        2
      ),
      _vm._v(" "),
      _c(
        "goo-modal",
        {
          attrs: { active: _vm.active },
          on: {
            "update:active": function($event) {
              _vm.active = $event;
            },
            close: _vm.close
          }
        },
        [
          _c("goo-close-button", {
            staticClass: "is-white-text-color",
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _vm.active
            ? _c(
                "div",
                { staticClass: "goo-lightbox-content" },
                [_vm._t("default")],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

  /* style */
  const __vue_inject_styles__$i = undefined;
  /* scoped */
  const __vue_scope_id__$i = undefined;
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$i = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$i = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$i);
  }

};

//
//
//
//
//
//
//
//
var script$j = {
  name: "goo-loader",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isFullscreen: {
      type: Boolean,
      default: true
    },
    delay: {
      type: Number
    }
  },

  data() {
    return {
      delayedLoading: false,
      timeout: null
    };
  },

  watch: {
    loading: {
      immediate: true,

      handler(loading) {
        clearTimeout(this.timeout);

        if (!this.delay || !loading) {
          return this.delayedLoading = loading;
        }

        this.timeout = setTimeout(() => {
          this.delayedLoading = loading;
        }, this.delay);
      }

    }
  },
  computed: {
    classNames() {
      return {
        "is-fullscreen": this.isFullscreen
      };
    }

  }
};

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: "fade-in" } }, [
    _vm.delayedLoading
      ? _c("div", { staticClass: "goo-loader", class: _vm.classNames }, [
          _c("div", { staticClass: "goo-loader-spinner" })
        ])
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;

  /* style */
  const __vue_inject_styles__$j = undefined;
  /* scoped */
  const __vue_scope_id__$j = undefined;
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$j = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$j = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$j);
  }

};

//
var script$k = {
  name: "goo-notification",
  components: {
    GooCloseButton: __vue_component__$7
  },
  props: {
    active: {
      type: Boolean,
      default: true
    },
    closable: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom-right',

      validate(value) {
        return ['top', 'top-left', 'top-right', 'bottom', 'bottom-left', 'bottom-right'].indexOf(value) !== -1;
      }

    },
    message: {
      type: String
    },
    autoClose: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 2000
    }
  },

  data() {
    return {
      isActive: this.active,
      timer: null
    };
  },

  watch: {
    active(value) {
      this.isActive = value;
    },

    isActive(value) {
      if (value) {
        this.setupAutoClose();
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
        }
      }
    }

  },
  computed: {
    className() {
      return [`is-${this.position}`];
    },

    transition() {
      switch (this.position) {
        case 'top':
          return 'fade-down';

        case 'bottom':
          return 'fade-up';

        case 'top-left':
        case 'bottom-left':
          return 'fade-left';

        case 'top-right':
        case 'bottom-right':
          return 'fade-right';

        default:
          return null;
      }
    }

  },
  methods: {
    close() {
      this.isActive = false;
      this.$emit("update:active", false);
      this.$emit("close");
    },

    setupAutoClose() {
      if (this.autoClose) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (this.isActive) {
            this.close();
          }
        }, this.duration);
      }
    }

  },

  mounted() {
    this.setupAutoClose();
  }

};

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: _vm.transition } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isActive,
            expression: "isActive"
          }
        ],
        staticClass: "goo-notification",
        class: _vm.className
      },
      [
        _vm.closable
          ? _c(
              "button",
              {
                staticClass: "goo-notification-close",
                attrs: { type: "button" },
                on: { click: _vm.close }
              },
              [_c("goo-icon", { attrs: { name: "close", width: "16" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.message ? _c("p", [_vm._v(_vm._s(_vm.message))]) : _vm._t("default")
      ],
      2
    )
  ])
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;

  /* style */
  const __vue_inject_styles__$k = undefined;
  /* scoped */
  const __vue_scope_id__$k = undefined;
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$k = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$k = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$k);
  }

};

//
//
//
//
//
//
//
var script$l = {
  name: "goo-password",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      password: this.value,
      show: false
    };
  },

  computed: {
    inputType() {
      return this.show ? 'text' : 'password';
    },

    buttonText() {
      return this.show ? 'Hide' : 'Show';
    },

    showButton() {
      return this.password && this.password.length > 0;
    }

  },
  watch: {
    value(value) {
      this.password = value;
    }

  },
  methods: {
    onInput() {
      this.$emit('input', this.password);
    },

    onToggleClick() {
      this.show = !this.show;
    }

  }
};

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-password" }, [
    _vm.inputType === "checkbox"
      ? _c(
          "input",
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass: "goo-password-input goo-input",
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.password)
                  ? _vm._i(_vm.password, null) > -1
                  : _vm.password
              },
              on: {
                input: _vm.onInput,
                change: function($event) {
                  var $$a = _vm.password,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false;
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v);
                    if ($$el.checked) {
                      $$i < 0 && (_vm.password = $$a.concat([$$v]));
                    } else {
                      $$i > -1 &&
                        (_vm.password = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)));
                    }
                  } else {
                    _vm.password = $$c;
                  }
                }
              }
            },
            "input",
            _vm.$attrs,
            false
          )
        )
      : _vm.inputType === "radio"
      ? _c(
          "input",
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass: "goo-password-input goo-input",
              attrs: { type: "radio" },
              domProps: { checked: _vm._q(_vm.password, null) },
              on: {
                input: _vm.onInput,
                change: function($event) {
                  _vm.password = null;
                }
              }
            },
            "input",
            _vm.$attrs,
            false
          )
        )
      : _c(
          "input",
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass: "goo-password-input goo-input",
              attrs: { type: _vm.inputType },
              domProps: { value: _vm.password },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value;
                  },
                  _vm.onInput
                ]
              }
            },
            "input",
            _vm.$attrs,
            false
          )
        ),
    _vm._v(" "),
    _vm.showButton
      ? _c(
          "button",
          {
            staticClass: "goo-password-button",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                $event.preventDefault();
                return _vm.onToggleClick($event)
              }
            }
          },
          [_vm._v(_vm._s(_vm.buttonText))]
        )
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;

  /* style */
  const __vue_inject_styles__$l = undefined;
  /* scoped */
  const __vue_scope_id__$l = undefined;
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$l = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$l = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$l);
  }

};

//
//
//
//
//
//
//
var script$m = {
  name: "goo-phone",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    countryCode: {
      type: Number,
      default: 1
    }
  },
  computed: {
    listeners() {
      const {
        input,
        ...listeners
      } = this.$listeners;
      return listeners;
    },

    attrs() {
      const { ...attrs
      } = this.$attrs;
      return attrs;
    }

  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    }

  }
};

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-phone" }, [
    _c("span", { staticClass: "goo-phone-country-code" }, [
      _vm._v("+" + _vm._s(_vm.countryCode))
    ]),
    _vm._v(" "),
    _c(
      "input",
      _vm._g(
        _vm._b(
          {
            staticClass: "goo-phone-input goo-input",
            attrs: { type: "tel" },
            domProps: { value: _vm.value },
            on: { input: _vm.onInput }
          },
          "input",
          _vm.attrs,
          false
        ),
        _vm.listeners
      )
    )
  ])
};
var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;

  /* style */
  const __vue_inject_styles__$m = undefined;
  /* scoped */
  const __vue_scope_id__$m = undefined;
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$m = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$m = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$m);
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$n = {
  name: "goo-polar-area-chart",
  props: {
    data: {
      type: Array,
      required: true,

      validate(data) {
        return data.filter(dataPoint => {
          return !dataPoint.value || !dataPoint.color || !dataPoint.label;
        });
      }

    },
    labelOffset: {
      type: Number,
      default: 0.15
    }
  },

  data() {
    return {
      labelFontSize: 0.075 // TODO We need to dynamically calculate this from the computed size

    };
  },

  computed: {
    labelRadius() {
      return this.labelOffset + 1;
    },

    clipPaths() {
      return this.data.map((dataPoint, index) => {
        return {
          radius: dataPoint.value,
          id: 'clip-' + index
        };
      });
    },

    wedges() {
      return this.data.map((dataPoint, index) => {
        let arc = this.arcCoordinatesForWedge(index);
        return {
          id: 'wedge-' + index,
          clipPath: `url(#clip-${index})`,
          color: dataPoint.color,
          path: this.pathForArc(arc.start, arc.end) + ' L 0 0'
        };
      });
    },

    labels() {
      return this.data.map((dataPoint, index) => {
        let flipText = this.isInSouthernHemisphere(index);
        let offset = flipText ? this.labelRadius + this.labelFontSize : this.labelRadius;
        let arc = this.arcCoordinatesForWedge(index, offset);
        let path = this.pathForArc(arc.start, arc.end, offset, flipText);
        let label = {
          path: path,
          text: dataPoint.label,
          pathId: 'path-' + index,
          pathHref: '#path-' + index
        };
        return label;
      });
    },

    wedgeSize() {
      return 1 / this.data.length;
    },

    lines() {
      return this.data.map((dataPoint, index) => {
        let arc = this.arcCoordinatesForWedge(index);
        return arc.end;
      });
    }

  },
  methods: {
    arcCoordinatesForWedge(index, offset) {
      offset = offset || 1;
      let start = {
        x: offset,
        y: 0
      };
      let percent = index * this.wedgeSize;

      if (index > 0) {
        start = this.coordinatesForPercent(percent, offset);
      }

      let end = this.coordinatesForPercent(percent + this.wedgeSize, offset);
      return {
        start: start,
        end: end
      };
    },

    coordinatesForPercent(percent, radius) {
      radius = radius || 1;
      return {
        x: radius * Math.cos(2 * Math.PI * percent),
        y: radius * Math.sin(2 * Math.PI * percent)
      };
    },

    angleForPercent(percent) {
      return percent * 360;
    },

    isInSouthernHemisphere(index) {
      let arcCenterAngle = this.angleForPercent(index * this.wedgeSize + this.wedgeSize * 0.5);
      return arcCenterAngle > 90 && arcCenterAngle < 270;
    },

    pathForArc(start, end, radius, reverse) {
      radius = radius || 1;
      reverse = reverse || false;
      let startX = reverse ? end.x : start.x;
      let startY = reverse ? end.y : start.y;
      let endX = reverse ? start.x : end.x;
      let endY = reverse ? start.y : end.y;
      return `M ${startX} ${startY} A ${radius} ${radius} 0 0 ${reverse ? '0' : '1'} ${endX} ${endY}`;
    }

  }
};

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-polar-area-chart" }, [
    _c(
      "svg",
      {
        staticStyle: { transform: "rotate(-0.25turn)" },
        attrs: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "-1.25 -1.25 2.5 2.5"
        }
      },
      [
        _c(
          "defs",
          _vm._l(_vm.clipPaths, function(clipPath) {
            return _c(
              "clipPath",
              { key: clipPath.id, attrs: { id: clipPath.id } },
              [_c("circle", { attrs: { r: clipPath.radius } })]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm._l(_vm.wedges, function(wedge) {
          return _c("path", {
            attrs: {
              id: wedge.id,
              d: wedge.path,
              fill: wedge.color,
              "clip-path": wedge.clipPath
            }
          })
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "goo-polar-area-chart-line",
          attrs: { r: "1", fill: "white", "fill-opacity": "0" }
        }),
        _vm._v(" "),
        _vm._l(_vm.lines, function(line) {
          return _c("line", {
            staticClass: "goo-polar-area-chart-line",
            attrs: { x0: "0", y0: "0", x1: line.x, y1: line.y }
          })
        }),
        _vm._v(" "),
        _vm._l(_vm.labels, function(label) {
          return _c("g", [
            _c("path", {
              attrs: { id: label.pathId, fill: "none", d: label.path }
            }),
            _vm._v(" "),
            _c(
              "text",
              {
                staticClass: "goo-polar-area-chart-label",
                attrs: { "text-anchor": "middle" }
              },
              [
                _c(
                  "textPath",
                  _vm._b(
                    { attrs: { startOffset: "50%" } },
                    "textPath",
                    { "xlink:href": label.pathHref },
                    false
                  ),
                  [_vm._v(_vm._s(label.text) + "\n                ")]
                )
              ]
            )
          ])
        })
      ],
      2
    )
  ])
};
var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;

  /* style */
  const __vue_inject_styles__$n = undefined;
  /* scoped */
  const __vue_scope_id__$n = undefined;
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$n = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$n = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$n);
  }

};

var smoothScroll_polyfills_min = createCommonjsModule(function (module, exports) {
  /*! smooth-scroll v16.1.3 | (c) 2020 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */
  window.Element && !Element.prototype.closest && (Element.prototype.closest = function (e) {
    var t,
        n = (this.document || this.ownerDocument).querySelectorAll(e),
        o = this;

    do {
      for (t = n.length; 0 <= --t && n.item(t) !== o;);
    } while (t < 0 && (o = o.parentElement));

    return o;
  }), function () {
    if ("function" == typeof window.CustomEvent) return;

    function e(e, t) {
      t = t || {
        bubbles: !1,
        cancelable: !1,
        detail: void 0
      };
      var n = document.createEvent("CustomEvent");
      return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
    }

    e.prototype = window.Event.prototype, window.CustomEvent = e;
  }(), function () {
    for (var r = 0, e = ["ms", "moz", "webkit", "o"], t = 0; t < e.length && !window.requestAnimationFrame; ++t) window.requestAnimationFrame = window[e[t] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[e[t] + "CancelAnimationFrame"] || window[e[t] + "CancelRequestAnimationFrame"];

    window.requestAnimationFrame || (window.requestAnimationFrame = function (e, t) {
      var n = new Date().getTime(),
          o = Math.max(0, 16 - (n - r)),
          a = window.setTimeout(function () {
        e(n + o);
      }, o);
      return r = n + o, a;
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (e) {
      clearTimeout(e);
    });
  }(), function (e, t) {
      module.exports = t(e) ;
  }("undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof window ? window : commonjsGlobal, function (M) {

    var q = {
      ignore: "[data-scroll-ignore]",
      header: null,
      topOnEmptyHash: !0,
      speed: 500,
      speedAsDuration: !1,
      durationMax: null,
      durationMin: null,
      clip: !0,
      offset: 0,
      easing: "easeInOutCubic",
      customEasing: null,
      updateURL: !0,
      popstate: !0,
      emitEvents: !0
    },
        I = function () {
      var n = {};
      return Array.prototype.forEach.call(arguments, function (e) {
        for (var t in e) {
          if (!e.hasOwnProperty(t)) return;
          n[t] = e[t];
        }
      }), n;
    },
        r = function (e) {
      "#" === e.charAt(0) && (e = e.substr(1));

      for (var t, n = String(e), o = n.length, a = -1, r = "", i = n.charCodeAt(0); ++a < o;) {
        if (0 === (t = n.charCodeAt(a))) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");
        1 <= t && t <= 31 || 127 == t || 0 === a && 48 <= t && t <= 57 || 1 === a && 48 <= t && t <= 57 && 45 === i ? r += "\\" + t.toString(16) + " " : r += 128 <= t || 45 === t || 95 === t || 48 <= t && t <= 57 || 65 <= t && t <= 90 || 97 <= t && t <= 122 ? n.charAt(a) : "\\" + n.charAt(a);
      }

      return "#" + r;
    },
        F = function () {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    },
        L = function (e) {
      return e ? (t = e, parseInt(M.getComputedStyle(t).height, 10) + e.offsetTop) : 0;
      var t;
    },
        x = function (e, t, n) {
      0 === e && document.body.focus(), n || (e.focus(), document.activeElement !== e && (e.setAttribute("tabindex", "-1"), e.focus(), e.style.outline = "none"), M.scrollTo(0, t));
    },
        H = function (e, t, n, o) {
      if (t.emitEvents && "function" == typeof M.CustomEvent) {
        var a = new CustomEvent(e, {
          bubbles: !0,
          detail: {
            anchor: n,
            toggle: o
          }
        });
        document.dispatchEvent(a);
      }
    };

    return function (o, e) {
      var b,
          a,
          A,
          O,
          C = {};
      C.cancelScroll = function (e) {
        cancelAnimationFrame(O), O = null, e || H("scrollCancel", b);
      }, C.animateScroll = function (a, r, e) {
        C.cancelScroll();
        var i = I(b || q, e || {}),
            c = "[object Number]" === Object.prototype.toString.call(a),
            t = c || !a.tagName ? null : a;

        if (c || t) {
          var s = M.pageYOffset;
          i.header && !A && (A = document.querySelector(i.header));

          var n,
              o,
              u,
              l,
              m,
              d,
              f,
              h,
              p = L(A),
              g = c ? a : function (e, t, n, o) {
            var a = 0;
            if (e.offsetParent) for (; a += e.offsetTop, e = e.offsetParent;);
            return a = Math.max(a - t - n, 0), o && (a = Math.min(a, F() - M.innerHeight)), a;
          }(t, p, parseInt("function" == typeof i.offset ? i.offset(a, r) : i.offset, 10), i.clip),
              y = g - s,
              v = F(),
              w = 0,
              S = (n = y, u = (o = i).speedAsDuration ? o.speed : Math.abs(n / 1e3 * o.speed), o.durationMax && u > o.durationMax ? o.durationMax : o.durationMin && u < o.durationMin ? o.durationMin : parseInt(u, 10)),
              E = function (e) {
            var t, n, o;
            l || (l = e), w += e - l, d = s + y * (n = m = 1 < (m = 0 === S ? 0 : w / S) ? 1 : m, "easeInQuad" === (t = i).easing && (o = n * n), "easeOutQuad" === t.easing && (o = n * (2 - n)), "easeInOutQuad" === t.easing && (o = n < .5 ? 2 * n * n : (4 - 2 * n) * n - 1), "easeInCubic" === t.easing && (o = n * n * n), "easeOutCubic" === t.easing && (o = --n * n * n + 1), "easeInOutCubic" === t.easing && (o = n < .5 ? 4 * n * n * n : (n - 1) * (2 * n - 2) * (2 * n - 2) + 1), "easeInQuart" === t.easing && (o = n * n * n * n), "easeOutQuart" === t.easing && (o = 1 - --n * n * n * n), "easeInOutQuart" === t.easing && (o = n < .5 ? 8 * n * n * n * n : 1 - 8 * --n * n * n * n), "easeInQuint" === t.easing && (o = n * n * n * n * n), "easeOutQuint" === t.easing && (o = 1 + --n * n * n * n * n), "easeInOutQuint" === t.easing && (o = n < .5 ? 16 * n * n * n * n * n : 1 + 16 * --n * n * n * n * n), t.customEasing && (o = t.customEasing(n)), o || n), M.scrollTo(0, Math.floor(d)), function (e, t) {
              var n = M.pageYOffset;
              if (e == t || n == t || (s < t && M.innerHeight + n) >= v) return C.cancelScroll(!0), x(a, t, c), H("scrollStop", i, a, r), !(O = l = null);
            }(d, g) || (O = M.requestAnimationFrame(E), l = e);
          };

          0 === M.pageYOffset && M.scrollTo(0, 0), f = a, h = i, c || history.pushState && h.updateURL && history.pushState({
            smoothScroll: JSON.stringify(h),
            anchor: f.id
          }, document.title, f === document.documentElement ? "#top" : "#" + f.id), "matchMedia" in M && M.matchMedia("(prefers-reduced-motion)").matches ? x(a, Math.floor(g), !1) : (H("scrollStart", i, a, r), C.cancelScroll(!0), M.requestAnimationFrame(E));
        }
      };

      var t = function (e) {
        if (!e.defaultPrevented && !(0 !== e.button || e.metaKey || e.ctrlKey || e.shiftKey) && "closest" in e.target && (a = e.target.closest(o)) && "a" === a.tagName.toLowerCase() && !e.target.closest(b.ignore) && a.hostname === M.location.hostname && a.pathname === M.location.pathname && /#/.test(a.href)) {
          var t, n;

          try {
            t = r(decodeURIComponent(a.hash));
          } catch (e) {
            t = r(a.hash);
          }

          if ("#" === t) {
            if (!b.topOnEmptyHash) return;
            n = document.documentElement;
          } else n = document.querySelector(t);

          (n = n || "#top" !== t ? n : document.documentElement) && (e.preventDefault(), function (e) {
            if (history.replaceState && e.updateURL && !history.state) {
              var t = M.location.hash;
              t = t || "", history.replaceState({
                smoothScroll: JSON.stringify(e),
                anchor: t || M.pageYOffset
              }, document.title, t || M.location.href);
            }
          }(b), C.animateScroll(n, a));
        }
      },
          n = function (e) {
        if (null !== history.state && history.state.smoothScroll && history.state.smoothScroll === JSON.stringify(b)) {
          var t = history.state.anchor;
          "string" == typeof t && t && !(t = document.querySelector(r(history.state.anchor))) || C.animateScroll(t, null, {
            updateURL: !1
          });
        }
      };

      C.destroy = function () {
        b && (document.removeEventListener("click", t, !1), M.removeEventListener("popstate", n, !1), C.cancelScroll(), O = A = a = b = null);
      };

      return function () {
        if (!("querySelector" in document && "addEventListener" in M && "requestAnimationFrame" in M && "closest" in M.Element.prototype)) throw "Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";
        C.destroy(), b = I(q, e || {}), A = b.header ? document.querySelector(b.header) : null, document.addEventListener("click", t, !1), b.updateURL && b.popstate && M.addEventListener("popstate", n, !1);
      }(), C;
    };
  });
});

var GooScrollNavigation = {
  name: 'goo-scroll-navigation',
  props: {
    offset: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      scroller: null
    };
  },

  render() {
    return this.$scopedSlots.default({
      scrollTo: this.scrollTo
    });
  },

  methods: {},

  mounted() {
    this.scroller = new smoothScroll_polyfills_min('a[href*="#"]', {
      speed: 300,
      header: '.goo-header'
    });
  }

};

const Plugin$o = {
  install(Vue) {
    registerComponent(Vue, GooScrollNavigation);
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$o = {
  name: "goo-search",
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    selectedValue: {
      type: String,
      default: null
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    minSearchLength: {
      type: Number,
      default: 1
    },
    inputClass: {
      type: [String, Array, Object],
      default: ""
    },
    showOnFocus: {
      type: Boolean,
      default: false
    },
    initialSearch: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      search: null,
      originalSearch: null,
      highlighting: false,
      highlightedIndex: -1,
      waiting: false,
      showDropDown: false
    };
  },

  watch: {
    search() {
      if (!this.highlighting) {
        if (this.hasValidSearch) {
          this.showDropDown = true;
          this.waiting = true;
          this.$emit("search", this.search);
        } else {
          this.showDropDown = false;
        }

        this.originalSearch = this.search;
      }
    },

    items() {
      this.waiting = false;
      this.highlightedIndex = -1;
    },

    highlightedIndex(value) {
      if (value >= 0) {
        this.highlighting = true;
      }
    }

  },
  computed: {
    showClearButton() {
      return this.allowClear && this.selectedValue && this.selectedValue.length > 0;
    },

    hasResults() {
      return this.items.length > 0;
    },

    showNoResults() {
      return !this.waiting && !this.hasResults;
    },

    inputValue() {
      if (this.highlighting && this.items[this.highlightedIndex]) {
        return this.items[this.highlightedIndex].name;
      } else if (this.selectedValue !== null) {
        return this.selectedValue;
      }

      return this.search;
    },

    hasValidSearch() {
      return this.search !== null && this.search.trim().length >= this.minSearchLength;
    },

    listeners() {
      const {
        blur,
        keydown,
        input,
        ...listeners
      } = this.$listeners;
      return listeners;
    },

    attrs() {
      const {
        autocomplete,
        ...attrs
      } = this.$attrs;
      return attrs;
    },

    hasHighlightedSelection() {
      return this.highlightedIndex >= 0;
    }

  },
  methods: {
    onInput(event) {
      this.$emit("input", event);
      this.search = event.target.value;
    },

    onKeyDown(event) {
      let key = event.key || event.keyCode;

      switch (key) {
        case 40:
        case "ArrowDown":
          event.preventDefault();
          this.highlightedIndex = this.highlightedIndex < this.items.length - 1 ? this.highlightedIndex + 1 : 0;
          break;

        case 38:
        case "ArrowUp":
          event.preventDefault();
          this.highlightedIndex = this.highlightedIndex > 0 ? this.highlightedIndex - 1 : this.items.length - 1;
          break;

        case 27:
        case "Escape":
          this.search = this.originalSearch;
          this.clear();
          break;

        case 13:
        case "Enter":
          if (this.hasHighlightedSelection) {
            event.preventDefault();
            this.onSelect(this.highlightedIndex);
          }

          break;

        default:
          this.highlighting = false;
          break;
      }
    },

    onMouseMove(index) {
      this.highlightedIndex = index;
    },

    onSelect(index) {
      this.$emit("selectResult", this.items[index]);
      this.clear();
      this.search = null;
      this.originalSearch = null;
    },

    onDocumentClick(event) {
      if (!this.$el.contains(event.target)) {
        this.clear();
        this.$emit("blur", event);
      }
    },

    onFocus() {
      if (this.showOnFocus && this.hasResults) {
        this.showDropDown = true;
      }
    },

    onBlur(event) {
      if (event.relatedTarget) {
        this.clear();
        this.$emit("blur", event);
      }
    },

    clear() {
      this.highlightedIndex = -1;
      this.highlighting = false;
      this.showDropDown = false;
    },

    clearSelection() {
      this.clear();
      this.$emit("clearResult");
      this.clearInputElement();
    },

    clearInputElement() {
      this.$refs.searchInput.value = "";
      const event = document.createEvent("Event");
      event.initEvent("input", true, true);
      this.$refs.searchInput.dispatchEvent(event);
    }

  },

  mounted() {
    document.addEventListener("click", this.onDocumentClick);

    if (this.initialSearch) {
      this.search = this.initialSearch;
    }
  },

  destroyed() {
    document.removeEventListener("click", this.onDocumentClick);
  }

};

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-search" }, [
    _c("div", { staticClass: "goo-control has-icons-left has-icons-right" }, [
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              ref: "searchInput",
              staticClass: "goo-input",
              class: _vm.inputClass,
              attrs: { type: "text", autocomplete: "off" },
              domProps: { value: _vm.inputValue },
              on: {
                keydown: _vm.onKeyDown,
                input: _vm.onInput,
                focus: _vm.onFocus,
                blur: _vm.onBlur
              }
            },
            "input",
            _vm.attrs,
            false
          ),
          _vm.listeners
        )
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "icon is-left" },
        [
          _c("goo-icon", {
            staticClass: "is-gray-extra-dark",
            attrs: { name: "spyglass", width: "24" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showClearButton
        ? _c(
            "button",
            {
              staticClass: "icon-button icon is-right",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault();
                  return _vm.clearSelection($event)
                }
              }
            },
            [
              _c("goo-icon", {
                attrs: { name: "cross-circle-outline", width: "24" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "is-sr-only" }, [_vm._v("Clear")])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDropDown
        ? _c(
            "div",
            {
              staticClass: "goo-search-dropdown",
              attrs: { "aria-live": "polite" }
            },
            [
              _vm.hasResults
                ? _c(
                    "ul",
                    { staticClass: "goo-search-result-list" },
                    _vm._l(_vm.items, function(result, index) {
                      return _c(
                        "li",
                        {
                          staticClass: "goo-search-result",
                          class: {
                            "is-highlighted": _vm.highlightedIndex == index
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSelect(index)
                            },
                            mousemove: function($event) {
                              return _vm.onMouseMove(index)
                            }
                          }
                        },
                        [
                          _vm._t(
                            "default",
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(result) +
                                  "\n                    "
                              )
                            ],
                            {
                              result: result,
                              isHighlighted: _vm.highlightedIndex == index
                            }
                          )
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showNoResults
                ? _vm._t(
                    "no-results",
                    [
                      _c("div", { staticClass: "goo-search-result" }, [
                        _c(
                          "div",
                          { staticClass: "goo-search-no-result-title" },
                          [
                            _vm._v(
                              'No results matched "' + _vm._s(_vm.search) + '".'
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "goo-search-no-result-subtitle" },
                          [
                            _vm._v(
                              "Check your spelling or try different keywords."
                            )
                          ]
                        )
                      ])
                    ],
                    { search: _vm.search }
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("footer")
            ],
            2
          )
        : _vm._e()
    ])
  ])
};
var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;

  /* style */
  const __vue_inject_styles__$o = undefined;
  /* scoped */
  const __vue_scope_id__$o = undefined;
  /* module identifier */
  const __vue_module_identifier__$o = undefined;
  /* functional template */
  const __vue_is_functional_template__$o = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$o = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$p = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$o);
  }

};

//
//
//
//
//
//
//
//
//
//
var script$p = {
  name: "goo-select",
  inheritAttrs: false,
  props: {
    value: {
      default: ''
    },
    options: {
      type: [Array, Object],
      required: true
    },
    showEmptySelection: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selection: this.value
    };
  },

  computed: {
    selectOptions() {
      if (Array.isArray(this.options)) {
        return this.options.map(option => {
          if (typeof option === 'object') {
            return option;
          }

          return {
            text: option,
            value: option
          };
        });
      } else {
        return Object.keys(this.options).map(key => {
          return {
            text: this.options[key],
            value: key
          };
        });
      }
    }

  },
  watch: {
    value(value) {
      this.selection = value;
    },

    selection() {
      this.$emit('input', this.selection);
    }

  }
};

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-select" }, [
    _c(
      "select",
      _vm._b(
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selection,
              expression: "selection"
            }
          ],
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value;
                  return val
                });
              _vm.selection = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0];
            }
          }
        },
        "select",
        _vm.$attrs,
        false
      ),
      [
        _vm.showEmptySelection
          ? _c(
              "option",
              { attrs: { selected: "selected", disabled: "", value: "" } },
              [_vm._v("Select")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.selectOptions, function(option) {
          return _c(
            "option",
            {
              attrs: { disabled: option.disabled },
              domProps: { value: option.value }
            },
            [_vm._v(_vm._s(option.text))]
          )
        })
      ],
      2
    )
  ])
};
var __vue_staticRenderFns__$o = [];
__vue_render__$o._withStripped = true;

  /* style */
  const __vue_inject_styles__$p = undefined;
  /* scoped */
  const __vue_scope_id__$p = undefined;
  /* module identifier */
  const __vue_module_identifier__$p = undefined;
  /* functional template */
  const __vue_is_functional_template__$p = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$p = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$q = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$p);
  }

};

var GooSlideshow = {
  name: 'goo-slideshow',
  props: {
    total: {
      type: Number
    },
    speed: {
      type: Number,
      default: 4
    }
  },

  data() {
    return {
      activeIndex: this.value || 0,
      slideInterval: null
    };
  },

  render() {
    return this.$scopedSlots.default({
      activeIndex: this.activeIndex,
      next: this.next,
      previous: this.previous,
      goTo: this.goTo
    });
  },

  methods: {
    setTimer() {
      window.clearInterval(this.slideInterval);
      this.slideInterval = window.setInterval(this.next, this.speed * 1000);
    },

    next() {
      if (this.activeIndex < this.total - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },

    previous() {
      if (this.activeIndex > 0) {
        this.activeIndex--;
      } else {
        this.activeIndex = this.total - 1;
      }
    },

    goTo(index) {
      this.activeIndex = index;
      this.setTimer();
    }

  },

  mounted() {
    this.setTimer();
  }

};

const Plugin$r = {
  install(Vue) {
    registerComponent(Vue, GooSlideshow);
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
var script$q = {
  name: "goo-split-progress",
  props: {
    value: {
      type: Number,
      required: true
    },
    steps: {
      type: Array,
      required: true,

      validate(value) {
        return value.length > 0;
      }

    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    }
  },
  computed: {
    sections() {
      return this.steps.map((step, index) => {
        let value = 0;

        if (this.activeSectionIndex < index) {
          value = 0;
        } else {
          const stepMin = this.stepSize * index;
          value = (this.value - stepMin) / this.stepSize;
          value = Math.min(value, 1);
        }

        return {
          label: step,
          value: value,
          style: `width: ${value * 100}%;`
        };
      });
    },

    stepSize() {
      return this.range / this.totalSteps;
    },

    range() {
      return this.max - this.min;
    },

    totalSteps() {
      return this.steps.length;
    },

    activeSectionIndex() {
      if (this.value <= this.min) {
        return -1;
      }

      const activeIndex = Math.ceil(this.value / this.stepSize) - 1;
      return Math.min(activeIndex, this.steps.length - 1); // Clamp to last index
    }

  }
};

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "goo-split-progress" },
    _vm._l(_vm.sections, function(section, index) {
      return _c("div", { staticClass: "goo-split-progress-section" }, [
        _c("div", { staticClass: "goo-split-progress-bar" }, [
          _c("div", {
            staticClass: "goo-split-progress-value",
            style: section.style
          })
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "goo-split-progress-label body-3",
            class: { "is-active": index == _vm.activeSectionIndex }
          },
          [_vm._v(_vm._s(section.label))]
        )
      ])
    }),
    0
  )
};
var __vue_staticRenderFns__$p = [];
__vue_render__$p._withStripped = true;

  /* style */
  const __vue_inject_styles__$q = undefined;
  /* scoped */
  const __vue_scope_id__$q = undefined;
  /* module identifier */
  const __vue_module_identifier__$q = undefined;
  /* functional template */
  const __vue_is_functional_template__$q = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$q = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
    __vue_inject_styles__$q,
    __vue_script__$q,
    __vue_scope_id__$q,
    __vue_is_functional_template__$q,
    __vue_module_identifier__$q,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$s = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$q);
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$r = {
  name: "goo-stars",
  props: {
    value: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      default: 5
    },
    formattedValue: {
      type: String,
      required: false
    }
  },
  computed: {
    readableValue() {
      return this.formattedValue || this.value;
    },

    title() {
      return `${this.readableValue} out of ${this.count} stars.`;
    },

    stars() {
      return Array(this.count).fill({}).map((star, index) => {
        let fill = 0;

        if (index < this.value) {
          fill = this.value - index > 1 ? 1 : this.value - index;
        }

        return {
          clipId: `goo-star-clip-${index}`,
          clipPath: `url(#goo-star-clip-${index})`,
          fill: fill,
          width: fill * 100
        };
      });
    }

  }
};

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    { staticClass: "goo-stars" },
    [
      _c("span", { staticClass: "is-sr-only" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _vm._l(_vm.stars, function(star, index) {
        return _c(
          "svg",
          {
            key: index,
            staticClass: "goo-star",
            attrs: { "aria-hidden": "true", viewBox: "0 0 100 100" }
          },
          [
            _c("defs", [
              _c("clipPath", { attrs: { id: star.clipId } }, [
                _c("rect", { attrs: { width: star.width, height: "100" } })
              ])
            ]),
            _vm._v(" "),
            _c("polygon", {
              staticClass: "goo-star-empty",
              attrs: {
                points:
                  "50 78 19.4351669 94.0688837 25.2725306 60.0344419 0.545061153 35.9311163 34.7175834 30.9655581 50 0 65.2824166 30.9655581 99.4549388 35.9311163 74.7274694 60.0344419 80.5648331 94.0688837"
              }
            }),
            _vm._v(" "),
            _c("polygon", {
              staticClass: "goo-star-filled",
              attrs: {
                "clip-path": star.clipPath,
                points:
                  "50 78 19.4351669 94.0688837 25.2725306 60.0344419 0.545061153 35.9311163 34.7175834 30.9655581 50 0 65.2824166 30.9655581 99.4549388 35.9311163 74.7274694 60.0344419 80.5648331 94.0688837"
              }
            })
          ]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$q = [];
__vue_render__$q._withStripped = true;

  /* style */
  const __vue_inject_styles__$r = undefined;
  /* scoped */
  const __vue_scope_id__$r = undefined;
  /* module identifier */
  const __vue_module_identifier__$r = undefined;
  /* functional template */
  const __vue_is_functional_template__$r = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$r = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
    __vue_inject_styles__$r,
    __vue_script__$r,
    __vue_scope_id__$r,
    __vue_is_functional_template__$r,
    __vue_module_identifier__$r,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$t = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$r);
  }

};

//
//
//
//
//
//
//
var script$s = {
  name: "goo-step-progress",
  props: {
    max: {
      type: Number,
      default: 1
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    progressValueStyle() {
      return `width: ${this.progress * 100}%;`;
    },

    progress() {
      return this.value / this.max;
    }

  }
};

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "goo-step-progress",
      attrs: {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": _vm.max,
        "aria-valuenow": _vm.value
      }
    },
    [
      _vm._l(_vm.max - 1, function(n) {
        return _c(
          "span",
          {
            staticClass: "goo-step-progress-dot",
            attrs: { "aria-hidden": "true" }
          },
          [_vm._v("•")]
        )
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "goo-step-progress-value",
        style: _vm.progressValueStyle
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$r = [];
__vue_render__$r._withStripped = true;

  /* style */
  const __vue_inject_styles__$s = undefined;
  /* scoped */
  const __vue_scope_id__$s = undefined;
  /* module identifier */
  const __vue_module_identifier__$s = undefined;
  /* functional template */
  const __vue_is_functional_template__$s = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$s = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
    __vue_inject_styles__$s,
    __vue_script__$s,
    __vue_scope_id__$s,
    __vue_is_functional_template__$s,
    __vue_module_identifier__$s,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$u = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$s);
  }

};

//
//
//
//
//
//
//
var script$t = {
  name: "goo-submit",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: [String, Boolean],
      default: "Submitting..."
    },
    type: {
      type: String,
      default: "submit"
    }
  },
  computed: {
    className() {
      return {
        "is-loading": this.loading,
        "is-empty": !this.loadingText && this.loading
      };
    },

    loadingButtonText() {
      return this.loadingText || "";
    },

    label() {
      if (!this.loadingText && this.loading) {
        return "Loading";
      }

      return false;
    }

  }
};

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          class: _vm.className,
          attrs: { type: _vm.type, "aria-label": _vm.label }
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm.loading ? [_vm._v(_vm._s(_vm.loadingButtonText))] : _vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$s = [];
__vue_render__$s._withStripped = true;

  /* style */
  const __vue_inject_styles__$t = undefined;
  /* scoped */
  const __vue_scope_id__$t = undefined;
  /* module identifier */
  const __vue_module_identifier__$t = undefined;
  /* functional template */
  const __vue_is_functional_template__$t = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$t = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
    __vue_inject_styles__$t,
    __vue_script__$t,
    __vue_scope_id__$t,
    __vue_is_functional_template__$t,
    __vue_module_identifier__$t,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$v = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$t);
  }

};

//
//
//
//
//
//
var script$u = {
  name: "goo-tab",
  props: {
    name: {
      type: String
    },
    icon: {
      type: String
    },
    activeClassName: {
      default: 'goo-tab-active'
    }
  },

  data() {
    return {
      isActive: false
    };
  },

  computed: {
    className() {
      return this.isActive ? this.activeClassName : '';
    },

    id() {
      return this.name.replace(' ', '_').toLowerCase();
    },

    hash() {
      return `#${this.id}`;
    }

  },
  methods: {
    activate() {
      this.isActive = true;
    },

    deactivate() {
      this.isActive = false;
    }

  }
};

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    { staticClass: "goo-tab", class: _vm.className, attrs: { id: this.id } },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$t = [];
__vue_render__$t._withStripped = true;

  /* style */
  const __vue_inject_styles__$u = undefined;
  /* scoped */
  const __vue_scope_id__$u = undefined;
  /* module identifier */
  const __vue_module_identifier__$u = undefined;
  /* functional template */
  const __vue_is_functional_template__$u = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$u = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
    __vue_inject_styles__$u,
    __vue_script__$u,
    __vue_scope_id__$u,
    __vue_is_functional_template__$u,
    __vue_module_identifier__$u,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
var script$v = {
  name: "goo-tabs",
  props: {
    value: {
      type: Number,
      default: 0
    },
    activeTabClassName: {
      default: 'goo-tab-active'
    }
  },

  data() {
    return {
      tabs: [],
      activeTabIndex: this.value || 0
    };
  },

  watch: {
    value(value) {
      this.selectTab(value);
    }

  },
  methods: {
    onSelectTab(index, event) {
      event.preventDefault();
      this.selectTab(index);
    },

    selectTab(index) {
      if (index === this.activeTabIndex || !this.tabs[index]) {
        return;
      }

      this.tabs[this.activeTabIndex].deactivate();
      this.tabs[index].activate();
      this.activeTabIndex = index;
      this.$emit('input', index);
    }

  },

  mounted() {
    this.tabs[this.activeTabIndex].activate();
  },

  created() {
    this.tabs = this.$children;
    this.tabs.forEach(tab => tab.activeClassName = this.activeTabClassName);
  }

};

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "goo-tabs" },
    [
      _c(
        "ul",
        { staticClass: "goo-tabs-list" },
        _vm._l(_vm.tabs, function(tab, index) {
          return _c(
            "li",
            {
              staticClass: "goo-tabs-list-item",
              class: { "is-active": tab.isActive }
            },
            [
              _c(
                "a",
                {
                  staticClass: "goo-tabs-list-item-link",
                  attrs: { href: tab.hash },
                  on: {
                    click: function($event) {
                      return _vm.onSelectTab(index, $event)
                    }
                  }
                },
                [
                  tab.icon
                    ? _c("goo-icon", { attrs: { name: tab.icon } })
                    : _vm._e(),
                  _c("span", { domProps: { innerHTML: _vm._s(tab.name) } })
                ],
                1
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
};
var __vue_staticRenderFns__$u = [];
__vue_render__$u._withStripped = true;

  /* style */
  const __vue_inject_styles__$v = undefined;
  /* scoped */
  const __vue_scope_id__$v = undefined;
  /* module identifier */
  const __vue_module_identifier__$v = undefined;
  /* functional template */
  const __vue_is_functional_template__$v = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$v = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
    __vue_inject_styles__$v,
    __vue_script__$v,
    __vue_scope_id__$v,
    __vue_is_functional_template__$v,
    __vue_module_identifier__$v,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$w = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$u);
    registerComponent(Vue, __vue_component__$v);
  }

};

//
//
//
//
//
//
//
//
//
var script$w = {
  name: "goo-textarea",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    maximum: [String, Number]
  },

  data() {
    return {
      text: this.value
    };
  },

  watch: {
    value(value) {
      this.text = value;
    }

  },
  computed: {
    characterCount() {
      return this.text.length || 0;
    },

    className() {
      return this.characterCount > this.maximum ? 'has-error' : '';
    },

    listeners() {
      const {
        input,
        ...listeners
      } = this.$listeners;
      return listeners;
    },

    attrs() {
      const { ...attrs
      } = this.$attrs;
      return attrs;
    }

  },
  methods: {
    onInput() {
      this.$emit('input', this.text);
    }

  }
};

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-textarea", class: _vm.className }, [
    _c(
      "textarea",
      _vm._g(
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.text,
                expression: "text"
              }
            ],
            staticClass: "goo-input",
            domProps: { value: _vm.text },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.text = $event.target.value;
                },
                _vm.onInput
              ]
            }
          },
          "textarea",
          _vm.attrs,
          false
        ),
        _vm.listeners
      )
    ),
    _vm._v(" "),
    _vm.maximum
      ? _c("div", { staticClass: "goo-textarea-count" }, [
          _c("span", { staticClass: "goo-input-hint" }, [
            _vm._v(_vm._s(_vm.characterCount) + "/" + _vm._s(_vm.maximum))
          ])
        ])
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$v = [];
__vue_render__$v._withStripped = true;

  /* style */
  const __vue_inject_styles__$w = undefined;
  /* scoped */
  const __vue_scope_id__$w = undefined;
  /* module identifier */
  const __vue_module_identifier__$w = undefined;
  /* functional template */
  const __vue_is_functional_template__$w = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$w = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
    __vue_inject_styles__$w,
    __vue_script__$w,
    __vue_scope_id__$w,
    __vue_is_functional_template__$w,
    __vue_module_identifier__$w,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$x = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$w);
  }

};

//
var script$x = {
  name: "goo-time-picker",
  mixins: [UniqueId],
  props: {
    value: {
      type: Array,
      required: true
    },
    times: {
      type: Array,
      required: true,
      validator: function (value) {
        return value.reduce((valid, next) => valid && next instanceof Date || typeof next === 'object' && next.date instanceof Date, true);
      }
    },
    formatter: {
      type: Function,
      default: toTinyTimeString
    }
  },

  data() {
    return {
      timesOptions: this.getTimeOptions(),
      dragging: false,
      dragStartIndex: null,
      dragEndIndex: null,
      dragStartTimeout: null
    };
  },

  computed: {
    checkedDates() {
      return this.timesOptions.filter(option => !option.dateDisabled && option.checked).map(option => option.date);
    },

    optionElements() {
      return Array.from(this.$el.querySelectorAll(".goo-time-picker-label"));
    },

    selectedStartIndex() {
      return Math.min(this.dragStartIndex, this.dragEndIndex);
    },

    selectedEndIndex() {
      return Math.max(this.dragStartIndex, this.dragEndIndex);
    }

  },
  methods: {
    getTimeOptions() {
      return this.times.map(time => {
        let item = time;

        if (time instanceof Date) {
          item = {
            date: time,
            dateDisabled: false
          };
        }

        item.checked = this.isChecked(item);
        return item;
      });
    },

    containsTime(date) {
      return this.value.filter(value => value.getTime() - date.getTime() === 0).length > 0;
    },

    isChecked(option) {
      return !option.dateDisabled && this.containsTime(option.date);
    },

    toggleCheckedOptions() {
      this.timesOptions.forEach(option => option.checked = this.isChecked(option));
    },

    onTouchStart(index) {
      this.dragStartTimeout = setTimeout(() => {
        this.onDragStart(index);
      }, 100);
    },

    onDragStart(index) {
      this.dragging = true;
      this.dragStartIndex = index;
      this.dragEndIndex = index;
      this.selectRange();
    },

    onDragMove(index) {
      if (this.dragging) {
        this.dragEndIndex = index;
        this.selectRange();
      }
    },

    onTouchMove(e) {
      clearTimeout(this.dragStartTimeout);

      if (this.dragging) {
        e.preventDefault();
        const touchCoordinates = {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY
        };
        this.optionElements.forEach((option, index) => {
          if (this.containsPoint(option, touchCoordinates)) {
            this.dragEndIndex = index;
            this.selectRange();
          }
        });
      }
    },

    containsPoint(element, point) {
      const rect = element.getBoundingClientRect();
      return point.x >= rect.x && point.x <= rect.x + rect.width && point.y >= rect.y && point.y <= rect.y + rect.height;
    },

    selectRange() {
      this.deselect();
      this.optionElements.slice(this.selectedStartIndex, this.selectedEndIndex + 1).forEach(optionElement => optionElement.classList.add("is-selected"));
    },

    deselect() {
      this.optionElements.forEach(optionElement => optionElement.classList.remove("is-selected"));
    },

    onDragEnd() {
      if (!this.dragging) {
        return;
      }

      this.commitSelection();
      this.resetDrag();
    },

    commitSelection() {
      if (this.selectedStartIndex !== this.selectedEndIndex) {
        this.checkRange();
      } // If the selection started and stopped on the same item,
      // a click happened so the normal input behavior will handle it

    },

    checkRange() {
      this.timesOptions.slice(this.selectedStartIndex, this.selectedEndIndex + 1).forEach(option => {
        if (!option.dateDisabled) {
          option.checked = true;
        }
      });
    },

    resetDrag() {
      this.dragging = false;
      this.dragStartIndex = null;
      this.dragEndIndex = null;
      this.$nextTick(this.deselect);
    },

    formattedDate: toTinyTimeString
  },
  watch: {
    timesOptions: {
      handler() {
        this.$emit("input", this.timesOptions.filter(option => !option.dateDisabled && option.checked).map(option => option.date));
      },

      deep: true
    },

    value() {
      this.toggleCheckedOptions();
    },

    times() {
      this.timesOptions = this.getTimeOptions();
    }

  },

  created() {
    this.toggleCheckedOptions();
    document.addEventListener("mouseup", () => {
      this.onDragEnd();
    });
    document.addEventListener("touchend", () => {
      this.onDragEnd();
      clearTimeout(this.dragStartTimeout);
    });
  }

};

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "goo-time-picker" },
    _vm._l(_vm.timesOptions, function(timeOption, index) {
      return _c("div", { staticClass: "goo-time-picker-option" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.timesOptions[index].checked,
              expression: "timesOptions[index].checked"
            }
          ],
          staticClass: "goo-time-picker-input is-sr-only",
          attrs: {
            type: "checkbox",
            name: "goo-time-picker",
            id: _vm.keyedId(index),
            "aria-disabled": timeOption.dateDisabled
          },
          domProps: {
            value: timeOption.date,
            checked: Array.isArray(_vm.timesOptions[index].checked)
              ? _vm._i(_vm.timesOptions[index].checked, timeOption.date) > -1
              : _vm.timesOptions[index].checked
          },
          on: {
            change: function($event) {
              var $$a = _vm.timesOptions[index].checked,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = timeOption.date,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(
                      _vm.timesOptions[index],
                      "checked",
                      $$a.concat([$$v])
                    );
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.timesOptions[index],
                      "checked",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    );
                }
              } else {
                _vm.$set(_vm.timesOptions[index], "checked", $$c);
              }
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "goo-time-picker-label",
            class: { "is-disabled": timeOption.dateDisabled },
            attrs: { for: _vm.keyedId(index) },
            on: {
              mousedown: function($event) {
                return _vm.onDragStart(index)
              },
              touchstart: function($event) {
                return _vm.onTouchStart(index)
              },
              mousemove: function($event) {
                return _vm.onDragMove(index)
              },
              touchmove: function($event) {
                return _vm.onTouchMove($event, index)
              },
              mouseup: function($event) {
                return _vm.onDragEnd()
              },
              touchend: function($event) {
                return _vm.onDragEnd()
              }
            }
          },
          [
            _vm._t(
              "default",
              [
                _c("span", { attrs: { "aria-hidden": "true" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.formatter(timeOption.date)) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "is-sr-only" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(timeOption.date.toLocaleTimeString()) +
                      "\n                "
                  )
                ])
              ],
              { time: timeOption.date, disabled: timeOption.dateDisabled }
            )
          ],
          2
        )
      ])
    }),
    0
  )
};
var __vue_staticRenderFns__$w = [];
__vue_render__$w._withStripped = true;

  /* style */
  const __vue_inject_styles__$x = undefined;
  /* scoped */
  const __vue_scope_id__$x = undefined;
  /* module identifier */
  const __vue_module_identifier__$x = undefined;
  /* functional template */
  const __vue_is_functional_template__$x = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$x = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
    __vue_inject_styles__$x,
    __vue_script__$x,
    __vue_scope_id__$x,
    __vue_is_functional_template__$x,
    __vue_module_identifier__$x,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$y = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$x);
  }

};

const EventBus = new Vue();

//
var script$y = {
  name: "goo-toasts",

  data() {
    return {
      toasts: []
    };
  },

  watch: {
    "$route": {
      handler: "displayFlash"
    },
    toasts: {
      immediate: true,
      handler: "toggleBodyClass"
    }
  },
  computed: {
    hasToasts() {
      return this.toasts.length > 0;
    }

  },
  methods: {
    getToastClass(toast) {
      return `is-${toast.type} ${typeof toast.onClick === "function" ? "is-clickable" : ""}`;
    },

    onToastClick(toast) {
      if (typeof toast.onClick === "function") {
        toast.onClick();
      }
    },

    addToast(toast) {
      let existing = this.findToast(toast.id);

      if (existing.length == 0) {
        this.toasts.push(toast);
      }
    },

    findToast(toastId) {
      return this.toasts.filter(toast => toast.id == toastId);
    },

    dismissToast(toastId) {
      let existing = this.findToast(toastId);

      if (existing.length !== 0) {
        this.removeToast(existing[0]);
      }
    },

    removeToast(toast) {
      this.toasts.splice(this.toasts.indexOf(toast), 1);
    },

    flashToast(toast) {
      sessionStorage.setItem("_toast", JSON.stringify(toast));
    },

    displayFlash() {
      if (sessionStorage.getItem("_toast")) {
        this.toasts.push(JSON.parse(sessionStorage.getItem("_toast")));
        sessionStorage.removeItem("_toast");
      }
    },

    toggleBodyClass() {
      if (this.hasToasts) {
        document.body.classList.add('has-toasts-open');
      }
    },

    onAfterLeave() {
      if (!this.hasToasts) {
        document.body.classList.remove('has-toasts-open');
      }
    }

  },

  created() {
    EventBus.$on("goo-toasts.add", this.addToast);
    EventBus.$on("goo-toasts.flash", this.flashToast);
    EventBus.$on("goo-toasts.dismiss", this.dismissToast);
    this.displayFlash();
  }

};

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "goo-toasts" },
    [
      _c(
        "transition-group",
        {
          staticClass: "goo-toasts-list",
          attrs: { tag: "ul", name: "fade" },
          on: { "after-leave": _vm.onAfterLeave }
        },
        _vm._l(_vm.toasts, function(toast) {
          return _c(
            "li",
            { key: toast.id, staticClass: "goo-toasts-list-item" },
            [
              _c(
                "div",
                {
                  staticClass: "goo-toast",
                  class: _vm.getToastClass(toast),
                  on: {
                    click: function($event) {
                      return _vm.onToastClick(toast)
                    }
                  }
                },
                [
                  _c("p", { staticClass: "goo-toast-message" }, [
                    _vm._v(_vm._s(toast.message))
                  ]),
                  _vm._v(" "),
                  toast.dismissable
                    ? _c(
                        "button",
                        {
                          staticClass: "icon-button goo-toast-dismiss",
                          on: {
                            click: function($event) {
                              $event.stopPropagation();
                              return _vm.dismissToast(toast.id)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "is-sr-only" }, [
                            _vm._v("Close")
                          ]),
                          _vm._v(" "),
                          _c("goo-icon", {
                            attrs: { name: "close", width: "16" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        }),
        0
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$x = [];
__vue_render__$x._withStripped = true;

  /* style */
  const __vue_inject_styles__$y = undefined;
  /* scoped */
  const __vue_scope_id__$y = undefined;
  /* module identifier */
  const __vue_module_identifier__$y = undefined;
  /* functional template */
  const __vue_is_functional_template__$y = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$y = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
    __vue_inject_styles__$y,
    __vue_script__$y,
    __vue_scope_id__$y,
    __vue_is_functional_template__$y,
    __vue_module_identifier__$y,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$z = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$y);
  }

};

var script$z = {
  name: "goo-toggle",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isActive: this.active
    };
  },

  watch: {
    active(value) {
      this.isActive = value;
    }

  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
      this.$emit("update:active", this.isActive);
    }

  },

  render(createElement) {
    const trigger = createElement("div", {
      staticClass: 'goo-toggle-trigger',
      on: {
        click: this.toggle
      }
    }, this.$scopedSlots.trigger ? [this.$scopedSlots.trigger({
      active: this.isActive
    })] : [this.$slots.trigger]);
    const content = this.$scopedSlots.default({
      active: this.isActive
    });
    return createElement("div", {
      staticClass: 'goo-toggle'
    }, [content, trigger]);
  }

};

/* script */
const __vue_script__$z = script$z;

/* template */

  /* style */
  const __vue_inject_styles__$z = undefined;
  /* scoped */
  const __vue_scope_id__$z = undefined;
  /* module identifier */
  const __vue_module_identifier__$z = undefined;
  /* functional template */
  const __vue_is_functional_template__$z = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$z = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__$z,
    __vue_script__$z,
    __vue_scope_id__$z,
    __vue_is_functional_template__$z,
    __vue_module_identifier__$z,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$A = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$z);
  }

};

const SIZES = ['B', 'KB', 'MB', 'GB', 'TB'];
function toBytes(size, unit) {
  let exponent = SIZES.indexOf(unit);

  if (exponent == -1) {
    throw new Error('Invalid unit "' + unit + '"');
  }

  return size * Math.pow(1000, exponent);
}
function toUnit(bytes, unit) {
  let exponent = SIZES.indexOf(unit);

  if (exponent == -1) {
    throw new Error('Invalid unit "' + unit + '"');
  }

  return bytes / Math.pow(1000, exponent);
}
function toHuman(bytes) {
  let unitIndex = Math.floor(Math.log(bytes) / Math.log(1000));
  let unit = SIZES[unitIndex];
  return this.toUnit(bytes, unit).toFixed(2) * 1 + ' ' + unit;
}
function fileIsType(file, type) {
  type = type.trim();

  if (type.charAt(0) === '.') {
    // Type is an extension
    let fileName = file.name.toLowerCase();
    let extension = type.toLowerCase();

    if (fileName.indexOf(extension, fileName.length - extension.length) !== -1) {
      return true;
    }
  } else if (/\/\*$/.test(type)) {
    // Type is a wildcard MIME Type
    let fileBaseMIMEType = file.type.replace(/\/.*$/, "");

    if (fileBaseMIMEType === type.replace(/\/.*$/, "")) {
      return true;
    }
  } else {
    if (file.type === type) {
      return true;
    }
  }

  return false;
}
var FileHelper = {
  toBytes: toBytes,
  toUnit: toUnit,
  toHuman: toHuman,
  fileIsType: fileIsType
};

const GooUploadStatus = {
  COMPLETE: 0,
  PENDING: 1,
  UPLOADING: 2,
  FAILED: 3,
  TOO_LARGE: 4,
  INVALID_TYPE: 5
};

//
var script$A = {
  name: "goo-upload-item",
  props: {
    upload: {
      type: Object,
      required: true
    },
    messages: {
      type: [Object, Array],

      default() {
        return {};
      }

    }
  },

  data() {
    let messages = [];
    messages[GooUploadStatus.FAILED] = 'Failed to upload.';
    messages[GooUploadStatus.PENDING] = 'Waiting.';
    messages[GooUploadStatus.COMPLETE] = 'Completed.';
    messages[GooUploadStatus.UPLOADING] = 'Uploading.';
    messages[GooUploadStatus.TOO_LARGE] = 'Failed to upload. File is too large.';
    messages[GooUploadStatus.INVALID_TYPE] = 'Failed to upload. File type is invalid.';
    return {
      GooUploadStatus: GooUploadStatus,
      statusMessages: Object.assign({}, messages, this.messages)
    };
  },

  computed: {
    fileIcon() {
      let icon = '';

      switch (this.upload.status) {
        case GooUploadStatus.PENDING:
        case GooUploadStatus.UPLOADING:
          icon = 'file-uploading.svg';
          break;

        case GooUploadStatus.COMPLETE:
          icon = 'file-success.svg';
          break;

        default:
          icon = 'file-failed.svg';
          break;
      }

      return '/images/icons/' + icon;
    },

    fileSize() {
      return FileHelper.toHuman(this.upload.file.size);
    },

    fileMessage() {
      return this.statusMessages[this.upload.status];
    },

    isError() {
      return this.upload.status >= GooUploadStatus.FAILED;
    },

    isCompleted() {
      return this.upload.status == GooUploadStatus.COMPLETE;
    },

    canRetry() {
      return this.upload.status == GooUploadStatus.FAILED;
    },

    fileName() {
      return this.upload.file.name;
    },

    fileNameStart() {
      return this.fileName.slice(0, Math.round(this.fileName.length / 2));
    },

    fileNameEnd() {
      return this.fileName.slice(this.fileNameStart.length);
    }

  },
  methods: {
    onRetryClick() {
      this.$emit('retry', this.upload);
    },

    onRemoveClick() {
      this.$emit('remove', this.upload);
    }

  }
};

/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "goo-upload-item" }, [
    _c("div", { staticClass: "goo-upload-icon" }, [
      _c(
        "svg",
        {
          attrs: {
            "aria-hidden": "true",
            height: "48",
            width: "48",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c("image", {
            attrs: { height: "48", width: "48", "xlink:href": _vm.fileIcon }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "goo-upload-details" }, [
      _c("header", { staticClass: "goo-upload-header" }, [
        _c("div", [
          _c("span", {
            staticClass: "goo-upload-name",
            attrs: {
              "aria-hidden": "true",
              "data-content-start": _vm.fileNameStart,
              "data-content-end": _vm.fileNameEnd
            }
          }),
          _vm._v(" "),
          _c("span", { ref: "fileName", staticClass: "is-sr-only" }, [
            _vm._v(_vm._s(_vm.fileName))
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "goo-upload-file-size is-gray-extra-dark-text-color"
            },
            [_vm._v(" - " + _vm._s(_vm.fileSize))]
          )
        ]),
        _vm._v(" "),
        _vm.isError || _vm.isCompleted
          ? _c(
              "button",
              {
                ref: "removeButton",
                staticClass: "goo-upload-delete goo-upload-control",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault();
                    return _vm.onRemoveClick($event)
                  }
                }
              },
              [
                _c("goo-icon", {
                  staticClass: "icon",
                  attrs: { name: "cross-circle-outline", width: "24" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "is-sr-only" }, [
                  _vm._v("Remove " + _vm._s(_vm.upload.file.name))
                ])
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("progress", {
        ref: "uploadProgress",
        staticClass: "goo-upload-progress",
        attrs: { max: "100" },
        domProps: { value: _vm.upload.progress }
      }),
      _vm._v(" "),
      _c("div", { ref: "uploadStatus", staticClass: "goo-upload-status" }, [
        _c("span", { class: { "is-error-text-color": _vm.isError } }, [
          _vm._v(_vm._s(_vm.fileMessage) + "\n                "),
          _vm.canRetry
            ? _c(
                "button",
                {
                  ref: "retryButton",
                  staticClass:
                    "goo-upload-retry goo-upload-control goo-link is-primary-text-color",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault();
                      return _vm.onRetryClick($event)
                    }
                  }
                },
                [_vm._v("Retry")]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
};
var __vue_staticRenderFns__$y = [];
__vue_render__$y._withStripped = true;

  /* style */
  const __vue_inject_styles__$A = undefined;
  /* scoped */
  const __vue_scope_id__$A = undefined;
  /* module identifier */
  const __vue_module_identifier__$A = undefined;
  /* functional template */
  const __vue_is_functional_template__$A = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$A = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
    __vue_inject_styles__$A,
    __vue_script__$A,
    __vue_scope_id__$A,
    __vue_is_functional_template__$A,
    __vue_module_identifier__$A,
    false,
    undefined,
    undefined,
    undefined
  );

//
var script$B = {
  name: "goo-upload",
  components: {
    GooUploadItem: __vue_component__$A
  },
  inheritAttrs: false,
  props: {
    uploads: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    maxFileSize: {
      type: Number,
      default: FileHelper.toBytes(16, 'MB')
    },
    maxFileCount: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      files: this.value,
      uploading: false,
      isDragOver: false
    };
  },

  computed: {
    canUploadMore() {
      if (!this.multiple) {
        return this.uploads.length === 0;
      }

      return this.uploads.length < this.maxFileCount;
    },

    fileMessages() {
      let messages = [];
      messages[GooUploadStatus.TOO_LARGE] = 'Failed to upload. File size exceeds ' + FileHelper.toHuman(this.maxFileSize);
      return messages;
    },

    fileNames() {
      return this.uploads.map(upload => upload.file.name).join(',');
    }

  },
  methods: {
    onChange(event) {
      this.onFilesAdded(event.target.files);
      event.target.value = '';
    },

    onDrop(event) {
      this.isDragOver = false;
      this.onFilesAdded(event.dataTransfer.files);
    },

    onFilesAdded(fileList) {
      let files = Array.from(fileList);

      if (this.tooManyFiles(files)) {
        this.$emit('fileCountExceeded', files, this.maxFileCount);
        return;
      }

      files.forEach(file => {
        let upload = {
          file: file,
          progress: 0,
          status: GooUploadStatus.PENDING,
          name: file.name
        };

        if (this.validUpload(upload)) {
          this.addUpload(upload);
        } else {
          this.invalidateUpload(upload);
        }
      });
      this.focusInput();
    },

    tooManyFiles(files) {
      return files.length + this.uploads.length > this.maxFileCount;
    },

    validUpload(upload) {
      if (!this.validSize(upload.file)) {
        upload.status = GooUploadStatus.TOO_LARGE;
        return false;
      }

      if (!this.validType(upload.file)) {
        upload.status = GooUploadStatus.INVALID_TYPE;
        return false;
      }

      return true;
    },

    validSize(file) {
      return this.maxFileSize && file.size <= this.maxFileSize;
    },

    validType(file) {
      if (!this.accept) {
        return true;
      }

      let types = this.accept.split(',');

      for (let type of types) {
        if (FileHelper.fileIsType(file, type)) {
          return true;
        }
      }

      return false;
    },

    addUpload(upload) {
      this.$emit('add', upload);
    },

    invalidateUpload(upload) {
      this.$emit('invalid', upload);
    },

    onRemove(upload) {
      this.removeUpload(upload);
    },

    removeUpload(upload) {
      this.$emit('remove', upload);
    },

    onRetry(upload) {
      this.retryUpload(upload);
    },

    onDragStart(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isDragOver = true;
    },

    onDragEnd(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isDragOver = false;
    },

    retryUpload(upload) {
      upload.progress = 0;
      upload.status = GooUploadStatus.PENDING;
      this.$emit('retry', upload);
    },

    onKeyboardClick() {
      this.$refs.fileInput.click();
    },

    focusInput() {
      this.$refs.labelButton.focus();
    }

  }
};

/* script */
const __vue_script__$B = script$B;

/* template */
var __vue_render__$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "goo-upload",
      on: {
        dragover: _vm.onDragStart,
        dragenter: _vm.onDragStart,
        drag: _vm.onDragStart,
        dragend: _vm.onDragEnd,
        dragleave: _vm.onDragEnd,
        drop: function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onDrop($event)
        }
      }
    },
    [
      _vm.canUploadMore
        ? _c(
            "div",
            {
              staticClass: "goo-upload-drop",
              class: { "is-dragover": _vm.isDragOver }
            },
            [
              _c("div", [
                _c("span", { staticClass: "is-gray-extra-dark-text-color" }, [
                  _vm._v("Drop files here, or")
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "goo-upload-label",
                    attrs: { for: _vm.$attrs.id }
                  },
                  [
                    _c(
                      "span",
                      {
                        ref: "labelButton",
                        staticClass: "goo-link",
                        attrs: {
                          tabindex: "0",
                          "aria-role": "button",
                          "aria-controls": _vm.$attrs.id
                        },
                        on: {
                          keypress: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault();
                            },
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault();
                            }
                          ],
                          keyup: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault();
                              return _vm.onKeyboardClick($event)
                            },
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault();
                              return _vm.onKeyboardClick($event)
                            }
                          ]
                        }
                      },
                      [_vm._v("Upload files")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "input",
                  _vm._b(
                    {
                      ref: "fileInput",
                      attrs: {
                        type: "file",
                        multiple: _vm.multiple,
                        accept: _vm.accept
                      },
                      on: { change: _vm.onChange }
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "goo-upload-list",
          attrs: { tag: "ul", name: "fade", "leave-active-class": "" }
        },
        _vm._l(_vm.uploads, function(upload, index) {
          return _c(
            "li",
            { key: index },
            [
              _c("goo-upload-item", {
                attrs: { messages: _vm.fileMessages, upload: upload },
                on: { retry: _vm.onRetry, remove: _vm.onRemove }
              })
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$z = [];
__vue_render__$z._withStripped = true;

  /* style */
  const __vue_inject_styles__$B = undefined;
  /* scoped */
  const __vue_scope_id__$B = undefined;
  /* module identifier */
  const __vue_module_identifier__$B = undefined;
  /* functional template */
  const __vue_is_functional_template__$B = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$B = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
    __vue_inject_styles__$B,
    __vue_script__$B,
    __vue_scope_id__$B,
    __vue_is_functional_template__$B,
    __vue_module_identifier__$B,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$B = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$B);
    registerComponent(Vue, __vue_component__$A);
  }

};

//
//
//
//
//
//
//
//
//
//
//
var script$C = {
  name: "goo-verification-code",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    codeLength: {
      type: Number,
      default: 4
    },
    allowedCharacters: {
      type: String,
      default: '[0-9]*'
    }
  },
  computed: {
    listeners() {
      const {
        input,
        paste,
        keydown,
        ...listeners
      } = this.$listeners;
      return listeners;
    },

    attrs() {
      const {
        pattern,
        ...attrs
      } = this.$attrs;
      return attrs;
    },

    allFields() {
      return Array.from(this.$el.querySelectorAll('.goo-verification-code-input'));
    },

    currentFieldIndex() {
      if (!this.code) {
        return 0;
      }

      if (!this.hasCharactersLeft) {
        return this.code.length - 1;
      }

      return this.code.length;
    },

    hasCharactersLeft() {
      return this.code.length < this.codeLength;
    },

    code() {
      return this.value || '';
    }

  },
  watch: {
    value() {
      this.updateFocus();
    }

  },
  methods: {
    onPaste(event) {
      let pastedText = event.clipboardData.getData('text');
      let code = pastedText.slice(0, this.codeLength);
      this.$emit('input', code);
      event.preventDefault();
    },

    onInput(event, index) {
      let code = this.code;

      if (this.hasCharactersLeft) {
        code += event.target.value;
      } else {
        code = this.replaceCharacterAtIndex(code, index, event.target.value);
      }

      this.$emit('input', code);
    },

    onKeyDown(event) {
      if (event.key === 'Backspace') {
        let code = this.code.slice(0, -1);
        this.$emit('input', code);
        event.preventDefault();
      }
    },

    replaceCharacterAtIndex(value, index, character) {
      return value.substr(0, index) + character + value.substr(index + 1);
    },

    valueAtIndex(index) {
      return this.code.charAt(index);
    },

    updateFocus() {
      this.focusFieldAtIndex(this.currentFieldIndex);
    },

    focusFieldAtIndex(index) {
      this.allFields[index].focus();
    }

  }
};

/* script */
const __vue_script__$C = script$C;

/* template */
var __vue_render__$A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "goo-verification-code" },
    _vm._l(_vm.codeLength, function(index) {
      return _c("div", { staticClass: "goo-verification-code-input-wrap" }, [
        _c(
          "label",
          {
            staticClass: "is-sr-only",
            attrs: { for: "verification_code_digit" + index }
          },
          [_vm._v("Digit " + _vm._s(index))]
        ),
        _vm._v(" "),
        _c(
          "input",
          _vm._g(
            _vm._b(
              {
                staticClass: "goo-input goo-verification-code-input",
                attrs: {
                  id: "verification_code_digit" + index,
                  type: "text",
                  maxlength: "1",
                  pattern: _vm.allowedCharacters
                },
                domProps: { value: _vm.valueAtIndex(index - 1) },
                on: {
                  paste: _vm.onPaste,
                  keydown: _vm.onKeyDown,
                  input: function($event) {
                    return _vm.onInput($event, index - 1)
                  }
                }
              },
              "input",
              _vm.attrs,
              false
            ),
            _vm.listeners
          )
        )
      ])
    }),
    0
  )
};
var __vue_staticRenderFns__$A = [];
__vue_render__$A._withStripped = true;

  /* style */
  const __vue_inject_styles__$C = undefined;
  /* scoped */
  const __vue_scope_id__$C = undefined;
  /* module identifier */
  const __vue_module_identifier__$C = undefined;
  /* functional template */
  const __vue_is_functional_template__$C = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$C = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
    __vue_inject_styles__$C,
    __vue_script__$C,
    __vue_scope_id__$C,
    __vue_is_functional_template__$C,
    __vue_module_identifier__$C,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$C = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$C);
  }

};

//
//
//
//
var script$D = {
  name: "goo-zip",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      zip: this.isFullZip(this.value) ? this.value : ''
    };
  },

  watch: {
    value(value) {
      if (this.isFullZip(value)) {
        this.zip = value;
      } else {
        this.zip = '';
      }
    }

  },
  computed: {
    listeners() {
      const {
        input,
        ...listeners
      } = this.$listeners;
      return listeners;
    },

    attrs() {
      const {
        type,
        pattern,
        ...attrs
      } = this.$attrs;
      return attrs;
    },

    zipValue() {
      if (this.isFullZip(this.zip)) {
        return this.zip;
      }

      return null;
    }

  },
  methods: {
    onInput(event) {
      if (this.isPartialZip(event.target.value)) {
        this.zip = event.target.value;
      } else {
        event.target.value = this.zip;
      }

      this.$emit("input", this.zipValue);
    },

    isFullZip(value) {
      return /^\d{5}$/.test(value);
    },

    isPartialZip(value) {
      return /^\d{0,5}$/.test(value);
    }

  }
};

/* script */
const __vue_script__$D = script$D;

/* template */
var __vue_render__$B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "input",
    _vm._g(
      _vm._b(
        {
          staticClass: "goo-input",
          attrs: { type: "text", pattern: "[0-9]*" },
          domProps: { value: _vm.zip },
          on: { input: _vm.onInput }
        },
        "input",
        _vm.attrs,
        false
      ),
      _vm.listeners
    )
  )
};
var __vue_staticRenderFns__$B = [];
__vue_render__$B._withStripped = true;

  /* style */
  const __vue_inject_styles__$D = undefined;
  /* scoped */
  const __vue_scope_id__$D = undefined;
  /* module identifier */
  const __vue_module_identifier__$D = undefined;
  /* functional template */
  const __vue_is_functional_template__$D = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$D = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
    __vue_inject_styles__$D,
    __vue_script__$D,
    __vue_scope_id__$D,
    __vue_is_functional_template__$D,
    __vue_module_identifier__$D,
    false,
    undefined,
    undefined,
    undefined
  );

const Plugin$D = {
  install(Vue) {
    registerComponent(Vue, __vue_component__$D);
  }

};

//     // The relative path of the components folder
//     ".",
//     // Whether or not to look in subfolders
//     true,
//     // The regular expression used to match base component filenames
//     /goo-[\w-]+\.(vue|js)$/
// );
//
// requireComponent.keys().forEach(fileName => {
//     // Get component config
//     const component = requireComponent(fileName);
//     // Base name without extension
//     const componentName = fileName.split(/[\\/]/).pop().replace(/\.\w+$/, "");
//     // Register component globally
//     Vue.component(componentName, component.default);
// });

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    GooAccordion: Plugin,
    GooBackgroundVideo: Plugin$1,
    GooBadge: Plugin$2,
    GooCalendar: Plugin$3,
    GooCarousel: Plugin$4,
    GooChecklist: Plugin$5,
    GooCircularProgress: Plugin$6,
    GooCloseButton: Plugin$7,
    GooCustomRadio: Plugin$8,
    GooDate: Plugin$9,
    GooDialog: Plugin$b,
    GooDropdown: Plugin$c,
    GooErrorDialog: Plugin$d,
    GooHeader: Plugin$e,
    GooIcon: Plugin$f,
    GooInViewport: Plugin$g,
    GooIncrement: Plugin$h,
    GooLightbox: Plugin$i,
    GooLoader: Plugin$j,
    GooModal: Plugin$a,
    GooNotification: Plugin$k,
    GooPassword: Plugin$l,
    GooPhone: Plugin$m,
    GooPolarAreaChart: Plugin$n,
    GooScrollNavigation: Plugin$o,
    GooSearch: Plugin$p,
    GooSelect: Plugin$q,
    GooSlideshow: Plugin$r,
    GooSplitProgress: Plugin$s,
    GooStars: Plugin$t,
    GooStepProgress: Plugin$u,
    GooSubmit: Plugin$v,
    GooTabs: Plugin$w,
    GooTextarea: Plugin$x,
    GooTimePicker: Plugin$y,
    GooToasts: Plugin$z,
    GooToggle: Plugin$A,
    GooUpload: Plugin$B,
    GooVerificationCode: Plugin$C,
    GooWindow: GooWindow,
    GooZip: Plugin$D
});

const requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame;
const ContainerTemplate = `<div class="goo-tip" role="tooltip">
    <button type="button" class="goo-tip-close icon-button">
        <svg width="12px" height="12px" viewBox="0 0 12 12">
            <g stroke="#3C4040" stroke-width="2" fill="none" stroke-linecap="round">
                <path d="M0,0 L12,12"></path>
                <path d="M0,12 L12,0"></path>
            </g>
        </svg>
        <span class="is-sr-only">Close</span>
    </button>
    <span class="goo-tip-triangle"></span>
    <div class="goo-tip-content">
    </div>
</div>`;
const registeredTips = [];
class ToolTip {
  constructor(targetEl, options) {
    this._targetEl = targetEl;
    this._options = options;
    this._scheduleTimer = null;
    this._container = null;
    this._closeButton = null;
    this._containerID = this._randomContainerID();
    this._touchMoving = false;
  }

  create() {
    this._container = this._makeContainer();
    this._closeButton = this._container.querySelector(".goo-tip-close");

    this._targetEl.setAttribute("role", "button");

    this._targetEl.setAttribute("aria-labelledby", this._containerID);

    this._targetEl.setAttribute("tabindex", 0);

    this.hide();

    this._setupEvents();

    registeredTips.push(this);
    return this._container;
  }

  show() {
    this.hideOtherTips();
    this._container.style.display = "";
    this.setPosition();
    requestAnimationFrame(() => {
      this._container.classList.add("is-visible");
    });
  }

  hide() {
    this._container.classList.remove("is-visible");

    this._container.addEventListener("transitionend", () => {
      if (!this.isVisible) {
        this._container.style.display = "none";
      }
    });
  }

  hideOtherTips() {
    this.otherTips.forEach(tip => tip.hide());
  }

  get isVisible() {
    return this._container.classList.contains("is-visible");
  }

  get otherTips() {
    return registeredTips.filter(tip => tip !== this);
  }

  scheduleShow(delay) {
    clearTimeout(this._scheduleTimer);
    this._scheduleTimer = window.setTimeout(this.show.bind(this), delay);
  }

  scheduleHide(delay) {
    clearTimeout(this._scheduleTimer);
    this._scheduleTimer = window.setTimeout(this.hide.bind(this), delay);
  }

  setPosition() {
    if (this._isSmallScreen()) {
      this._resetPosition();

      return;
    }

    const targetCenter = this.targetCenter;

    const width = this._getComputedContainerWidth();

    this._container.style.top = targetCenter.y + this.offset.y + "px";
    this._container.style.left = targetCenter.x + this.offset.x + "px";
    this._container.style.width = width;
  }

  _resetPosition() {
    this._container.style.top = "";
    this._container.style.left = "";
    this._container.style.width = "";
  }

  get offset() {
    const offset = this._options.offset;
    const position = this._options.position;

    const offsetCoordinates = this._getOffsetDelta(position);

    const positionCoordinates = this._getPositionDelta(position);

    const contentBox = this._container.getBoundingClientRect();

    return {
      x: contentBox.width * positionCoordinates.x + offsetCoordinates.x * offset,
      y: contentBox.height * positionCoordinates.y + offsetCoordinates.y * offset
    };
  }

  get targetCenter() {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    const scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft;

    const targetBox = this._targetEl.getBoundingClientRect();

    return {
      x: targetBox.left + scrollLeft + targetBox.width / 2,
      y: targetBox.top + scrollTop + targetBox.height / 2
    };
  }

  _getPositionDelta(position) {
    const parts = this._getPositionParts(position);

    const delta = {
      x: 0,
      y: 0
    };

    if (parts.indexOf("top") !== -1) {
      delta.y = -1;
    }

    if (parts.indexOf("left") !== -1) {
      delta.x = -1;
    }

    if (parts[1] == "middle") {
      if (parts[0] == "top" || parts[0] == "bottom") {
        delta.x = -0.5;
      } else {
        delta.y = -0.5;
      }
    }

    return delta;
  }

  _getOffsetDelta(position) {
    const parts = this._getPositionParts(position);

    const delta = {
      x: 1,
      y: 1
    };

    if (parts[0] == "top") {
      delta.y = -1;
    }

    if (parts[0] == "left") {
      delta.x = -1;
    }

    if (parts[1] == "bottom") {
      delta.y = -1;
    }

    if (parts[1] == "right") {
      delta.x = -1;
    }

    if (parts[1] == "middle") {
      if (parts[0] == "top" || parts[0] == "bottom") {
        delta.x = 0;
      } else {
        delta.y = 0;
      }
    }

    return delta;
  }

  _getPositionParts(position) {
    let parts = position.split("-");

    if (parts.length == 1) {
      parts.push("middle");
    }

    return parts;
  }

  _getComputedContainerWidth() {
    this._container.display = "";
    this._container.style.top = 0;
    this._container.style.left = 0;
    this._container.style.width = "auto";
    const style = window.getComputedStyle(this._container);
    this._container.display = "none";
    return style.width;
  }

  _makeContainer() {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = ContainerTemplate;
    const container = wrapper.childNodes[0];
    container.querySelector(".goo-tip-content").innerHTML = this._options.content;
    container.classList.add(`is-positioned-${this._options.position}`);
    container.setAttribute("id", this._containerID);
    container.style.display = "none";
    return container;
  }

  _toggleOnEvents(showEvent, hideEvent, delay) {
    const eventDelay = delay !== undefined ? delay : this._options.delay;

    this._targetEl.addEventListener(showEvent, () => {
      if (!this.isVisible) {
        this.scheduleShow(eventDelay);

        this._targetEl.addEventListener(hideEvent, () => {
          this.scheduleHide(eventDelay);
        });
      }
    });
  }

  _toggle(delay) {
    if (!this.isVisible) {
      this.scheduleShow(delay);
    } else {
      this.scheduleHide(delay);
    }
  }

  _setupEvents() {
    this._toggleOnEvents("mouseenter", "mouseleave");

    this._toggleOnEvents("focus", "blur", 0);

    this._targetEl.addEventListener("touchend", e => {
      if (!this._touchMoving) {
        e.stopImmediatePropagation();
        e.preventDefault();

        this._toggle(0);
      }
    });

    this._container.addEventListener("mouseenter", () => {
      if (this.isVisible) {
        this.scheduleShow(0);

        this._container.addEventListener("mouseleave", () => {
          this.scheduleHide(this._options.delay);
        });
      }
    });

    document.addEventListener("touchmove", () => this._touchMoving = true);
    document.addEventListener("touchend", e => {
      if (!this._touchMoving) {
        if (!this._isInContainer(e.target, this._container)) {
          this.hide();
        }
      } else {
        this._touchMoving = false;
      }
    });

    this._closeButton.addEventListener("touchend", e => {
      e.stopPropagation();
      e.preventDefault();
      this.hide();
    });
  }

  _isInContainer(el, container) {
    while (el) {
      if (el == container) {
        return true;
      }

      el = el.parentNode;
    }

    return false;
  }

  _randomContainerID() {
    return "goo-tip-" + Math.random().toString(36).replace(/[^a-z]+/g, "").substr(2, 10);
  }

  _isSmallScreen() {
    return window.innerWidth < 768;
  }

}

var vgootip = {
  bind(el, binding, vnode, oldVnode) {
    const position = Object.keys(binding.modifiers);
    const options = {
      delay: 300,
      offset: 20,
      position: position.length == 0 ? 'top-middle' : position.join('-'),
      content: typeof binding.value == 'string' ? binding.value : binding.value.content
    };
    const toolTip = new ToolTip(el, options);
    document.body.appendChild(toolTip.create());
    el.classList.add("has-goo-tip");
  }

};

function install(Vue, options = {}) {
  Vue.directive('goo-tip', vgootip);
}

const PRE_LOADING_HEIGHT = 1.3;

const onImageLoad = event => {
  const element = event.target;
  element.classList.remove("is-loading");
  element.classList.add("is-loaded");
  element.removeEventListener("load", onImageLoad);
};

const load = element => {
  const src = element.dataset.src;
  element.classList.add("is-loading");
  element.classList.remove("is-waiting");
  element.addEventListener("load", onImageLoad);

  if (element.dataset.backgroundImage !== undefined) {
    element.style.backgroundImage = `url('${src}')`;
  } else {
    if (element.dataset.srcset) {
      element.srcset = element.dataset.srcset;
    }

    element.src = src;
  }
};

const observer = (() => {
  if ("IntersectionObserver" in window) {
    return new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const element = entry.target;
          load(element);
          observer.unobserve(element);
        }
      });
    }, {
      rootMargin: window.innerHeight * (PRE_LOADING_HEIGHT - 1) + "px"
    });
  } else {
    return {
      observe: load
    };
  }
})();

class LazyLoader {
  constructor(element, src, options) {
    for (const key in options) {
      element.setAttribute(`data-${key}`, "");
    }

    element.classList.add("goo-lazy", "is-waiting");
    element.dataset.src = src;
    observer.observe(element);
  }

}

var lazy = {
  bind(el, binding, vnode, oldVnode) {
    new LazyLoader(el, binding.value, binding.modifiers);
  }

};

function install$1(Vue, options = {}) {
  Vue.directive('goo-lazy', lazy);
}

Vue.use(install);
Vue.use(install$1);

var directives = /*#__PURE__*/Object.freeze({
    __proto__: null,
    GooTip: install,
    GooLazy: install$1
});

const Goo = {
  install(Vue, options = {}) {
    // Components
    for (let componentKey in components) {
      Vue.use(components[componentKey]);
    } // Directives


    for (let directiveKey in directives) {
      Vue.use(directives[directiveKey]);
    }
  }

};

export default Goo;
export { Plugin as GooAccordion, Plugin$1 as GooBackgroundVideo, Plugin$2 as GooBadge, Plugin$3 as GooCalendar, Plugin$4 as GooCarousel, Plugin$5 as GooChecklist, Plugin$6 as GooCircularProgress, Plugin$7 as GooCloseButton, Plugin$8 as GooCustomRadio, Plugin$9 as GooDate, Plugin$b as GooDialog, Plugin$c as GooDropdown, Plugin$d as GooErrorDialog, Plugin$e as GooHeader, Plugin$f as GooIcon, Plugin$g as GooInViewport, Plugin$h as GooIncrement, install$1 as GooLazy, Plugin$i as GooLightbox, Plugin$j as GooLoader, Plugin$a as GooModal, Plugin$k as GooNotification, Plugin$l as GooPassword, Plugin$m as GooPhone, Plugin$n as GooPolarAreaChart, Plugin$o as GooScrollNavigation, Plugin$p as GooSearch, Plugin$q as GooSelect, Plugin$r as GooSlideshow, Plugin$s as GooSplitProgress, Plugin$t as GooStars, Plugin$u as GooStepProgress, Plugin$v as GooSubmit, Plugin$w as GooTabs, Plugin$x as GooTextarea, Plugin$y as GooTimePicker, install as GooTip, Plugin$z as GooToasts, Plugin$A as GooToggle, Plugin$B as GooUpload, Plugin$C as GooVerificationCode, GooWindow, Plugin$D as GooZip, ProgrammaticDialog };
